import { mapActions, mapGetters, mapMutations } from "vuex";
import DatePicker from "vue2-datepicker";
import { cloneDeep, uniqBy, get, isEqual } from "lodash";
import JsonCSV from "vue-json-csv";
import { DateTime } from "luxon";
import mainAxios from "@/axios";
// import osintAxios from "@shared/light-ray/axios/osint-axios";
import { EventBus } from "@/main.js";

import analysisCard from "@shared/saas-components/ToolsCard.vue";
import Input from "@shared/saas-components/input/index";
import NeoPagination from "@shared/saas-components/pagination/index";
import VueMultiselect from "@shared/saas-components/vue-multiselect/index";
import MonitoringFilter  from "@shared/saas-components/monitoring-filter"; // moved
import ResultList from "@shared/saas-components/result-list"; // moved
import ResultExpanded from "@shared/saas-components/result-expanded"; // moved
import uploadButton from "@shared/components/upload-button"; // moved

import Button from "@shared/components/button";
import Loader from "@shared/loader";
// import toggleSwitch from "@shared/components/toggle-switch"; // moved
import ModalConfirm from "@/components/modal-confirm"; // Present in all apps 

import AdverseMediaResources from "@shared/tools/adverse-media/adverse-media-resources";
import neoSwitch from "@shared/components/toggle-switch"; // moved +
import Field from "@shared/tools/components/Field.vue";
import ExpandFilter from "@shared/tools/ExpandFilter.vue";
import FilterModal from "@shared/tools/FilterModal.vue";
import tools from "@shared/tools/mixins/tools";
import toolsHelper from "@shared/tools/mixins/toolsHelper"
import runAllQueries from "@shared/tools/mixins/runAllQueries";
import PermissionsMixin from "@shared/tools/mixins/permissions";
import tabsTools from "@shared/light-ray/pages/entity-details/tabs.vue"
import { mediaMonitoringTabs } from "@shared/tools/utils/toolsTabs.js"
import { convertToCSV, csvFileName, setUsernamesDropdownData } from "@shared/utils/functions";
import { SIGMA_TOOL_MAPPING } from "@shared/utils/constants";
import { monitoringSearchData, monitoringHistoryData, getMarkAllAsDone } from "@shared/utils/monitoringTools.js";
import { checkPermission } from "@shared/utils/functions";
import CheckToolPagination from "@shared/tools/components/check-tool-pagination.vue";

const generateFiltersWrapperModel = (title, src_name, value, filterSections, tagClass, disabled) => ({
    title,
    src_name,
    value,
    filterSections,
    tagClass,
    isChecked: false,
    isModalVisible: false,
    disabled,
});

export default {
    name: "neo-adverse-media",
   
    /**
     * @components - external components used in the component
     */
    components: {
        DatePicker,
        "neo-input": Input,
        "neo-button": Button,
        "neo-loader": Loader,
        "analysis-card": analysisCard,
        "download-csv": JsonCSV,
        "modal-confirm": ModalConfirm,
        NeoPagination,
        VueMultiselect,
        // toggleSwitch,
        ResultList,
        ResultExpanded,
        "neo-upload-button": uploadButton,
        AdverseMediaResources,
        ExpandFilter,
        FilterModal,
        neoSwitch,
        tabsTools,
        MonitoringFilter,
        Field,
        CheckToolPagination,
    },
    provide () {
      return {
        isCaseCreated: this.isCaseCreated
      }
    },
    props: {
        /**
         * @property
         * @name toolData - input data (case data + inputs run throught tools) for input types matching to selected tool
         */
        toolData: {
            type: Array,
            default: () => [],
        },
        /**
         * @property
         * @name tool - selected tool name
         */
        tool: {
            type: String,
            default: "",
        },
        isQueryPanelExpanded: {
            type: Boolean,
            default: false,
        },
        monitoring: {
            type: Boolean,
            default: false,
        },
        toolSearchQueries: Array,
        frequency: {
            default: "",
        },
        mainEntity: Array,
        /**
         * @typedef {Object} AutorunConfig
         * @property {Object} headers
         * @property {Object} params
         */
        /**
         * @type {AutorunConfig} autorun configurations
         */
        autorun: {
            type: Object,
            default: null,
        },
        title: {
            type: String,
            default: "MediaMonitoring",
        },
        checkId: {
            type: String,
            default: "",
        },
        entityId: {
            type: String,
            default: "",
        },
        isCaseCreated: {
            type: Boolean,
            default: false,
        },
        listDisabled: {
            type: Boolean,
            default: false,
        },
        prebuiltQuery: {
            type: Object,
            default: null,
        },
        entityTypeId: {
            type: String,
            default: "",
        },
    },
    mixins: [tools, toolsHelper, runAllQueries, PermissionsMixin],
    data: () => ({
        dataTypeOp: [
            {label: "All Results", tLabel: "components.tools.media_monitoring.all_results", value: "all_results"},
            {label: "Unacknowledged Results", tLabel: "components.tools.media_monitoring.unacknowledged_results", value: "unacknowledged"},
            {label: "Acknowledged Results", tLabel: "components.tools.media_monitoring.acknowledged_results", value: "acknowledged"},
        ],
        selectedDataType: {label: "All Results", value: "all_results"},
        dateRange: [],
        isBulkMonitoringLoading: false,
        monitoringActive: false,
        dateFilters: {
            minDate: 0,
            maxDate: 0,
            data: [],
        },
        riskCategoryOptions: [],
        showTabTools: false,
        totalCount: 0,
        cardStatusCounts: {
            all:0,
            confirmedCount: 0,
            unknownCount: 0,
            potentialCount: 0,
            irrelevantCount: 0
        },
        cardStatusResults: [],
        cardDetailsMap: {},
        tabsStatus: mediaMonitoringTabs.tabsModel,
        searchItem: "",
        loading: true,
        loaderController: {
            nameSearch: {
                loading: false,
                success: false,
                filterLoading: false,
                filterSuccess: false,
            },
        },
        isAllRunQueries: false,
        adverseResults: [],
        showResult: false,
        showFiltersPanel: false,
        queries: [],
        newEntity: null,
        entityCount: 1,
        selectedItem: null,
        triggerRoute: true,
        selectedResultCard: null,
        isOldVersionSelected: false,
        isResultExpanded: false,
        expandedResultCard: null,
        page_number: 1,
        items_count: 10,
        searchQuery: "",
        filterMatchedEntity: "",
        filterRiskType: [],
        filterEntityRisk: [],
        filterPublicationDate: [],
        filterPublisherCountry: [],
        filterPublisherRegion: [],
        filterPublisherSubRegion: [],
        filterMentions: [],
        filterLanguages: [],
        selectVal: [""],
        searchedClicked: false,
        tabName: "",
        allFilters: [],
        searchKeyword: "",
        dropValue: "",
        sources: ["sigma"],
        bulkMonitor: false,
        open: false,
        monitoringStatus: false,
        selected: "",
        inputlength: 0,
        entityType: "any",
        validdate: false,
        nameSearches: [],
        typeOptions: ["any", "person", "company", "vessel",  "aircraft"],
        /**
         * @property
         * @name allSources - sources data along with sources filters and title
         *                  - each source data returned through a function generateFiltersWrapperModel
         *                      - containing source title, source name mapping, source value mapping, and filters allowed
         */
        allSources: {
            mediaMonitoring: generateFiltersWrapperModel(
                "Media Monitoring",
                "media_monitoring",
                "mediaMonitoring",
                [
                    {
                        label: "Advanced Search",
                        tLabel: "components.tools.media_monitoring.advanced_search",
                        person_filters: ["aliases", "countries", "dob", "dateType", "dateRangeFilter"],
                        company_filters: ["aliases", "countries", "dateType", "dateRangeFilter"],
                        expanded: false,
                    },
                    {
                        label: "Predefined",
                        tLabel: "components.tools.media_monitoring.predefined",
                        person_filters: ["filter_id"],
                        company_filters: ["filter_id"],
                        expanded: false,
                    },
                ],
                "bg-green-300"
            ),
        },

        aliases: {
            label: "Aliases",
            tLabel: 'components.tools.media_monitoring.aliases',
            value: "",
            type: "string",
            class: "custom-cols-3",
            isSourceSpecific: true,
            props: {
              placeholder: "Aliases",
              tPlaceholder: 'components.tools.media_monitoring.aliases',
            },
        },

        countries: {
            label: "Country",
            tLabel: 'components.tools.media_monitoring.country',
            value: [],
            props: {
                options: [],
                groupLabel: "group",
                groupValues: "categories",
                groupSelect: true,
                trackBy: "value",
                label: "name",
                tLabel: 'components.tools.media_monitoring.name',
                multiple: true,
                limit: 3,
                checkboxes: true,
                placeholder: "Select Country",
                tPlaceholder: 'components.tools.media_monitoring.select_country',
                tagPlaceholder: "",
                closeOnSelect: false,
                showLabels: false,
            },
            class: "custom-cols-3",
            isSourceSpecific: false,
        },

        
        /**
         * @property
         * @name dateOfBirth - date of birth filter data
         */
        dob: {
            label: "DOB",
            tLabel: 'components.tools.media_monitoring.dob',
            value: null,
            class: "custom-cols-3",
            isSourceSpecific: true,
            drops: [
                {
                    value: null,
                    props: {
                        placeholder: "DD",
                        tPlaceholder: 'components.tools.media_monitoring.dd',
                        searchable: true,
                        checkboxes: false,
                        closeOnSelect: true,
                        showLabels: false,
                        maxHeight: 250,
                        tagPlaceholder: "",
                    },
                },
                {
                    value: null,
                    props: {
                        placeholder: "MM",
                        tPlaceholder: 'components.tools.media_monitoring.mm',
                        searchable: true,
                        checkboxes: false,
                        closeOnSelect: true,
                        showLabels: false,
                        maxHeight: 250,
                        tagPlaceholder: "",
                    },
                },
                {
                    value: null,
                    props: {
                        placeholder: "YYYY",
                        tPlaceholder: 'components.tools.media_monitoring.yyyy',
                        searchable: true,
                        checkboxes: false,
                        closeOnSelect: true,
                        showLabels: false,
                        maxHeight: 250,
                        tagPlaceholder: "",
                    },
                },
            ],
        },

        dateType: {
            label: "Select Date Range",
            tLabel: 'components.tools.media_monitoring.search_by_date',
            value: {
                value: "past_24_hrs",
            },
            props: {
                searchable: true,
                options: [{
                    value: "past_24_hrs",
                }, {
                    value: "past_week",
                }, {
                    value: "past_month",
                }, {
                    value: "past_year",
                }, {
                    value: "custom",
                }],
                trackBy: "name",
                label: "name",
                tLabel: 'components.tools.media_monitoring.name',
                multiple: false,
                checkboxes: true,
                closeOnSelect: true,
                showLabels: false,
                maxHeight: 250,
                placeholder: "Select date type",
                tPlaceholder: 'components.tools.media_monitoring.search_by_date',
                tagPlaceholder: "",
                allowEmpty: false
            },
            class: "custom-cols-2",
            isSourceSpecific: true,
        },

        dateRangeFilter: {
            label: "Select Date Range",
            tLabel: 'components.tools.media_monitoring.select_date_range',
            value: [],
            type: "datepicker",
            props: {
                maxHeight: 250,
                placeholder: "Select date range",
                tPlaceholder: 'components.tools.media_monitoring.select_date_range',
            },
            class: "custom-cols-2",
            isSourceSpecific: true,
        },
        
        /**
         * @property
         * @name Filter set - filter set
         */
        filter_id: {
            label: "Filter set",
            tLabel: 'components.tools.media_monitoring.filter_set',
            value: null,
            props: {
                searchable: true,
                options: [],
                trackBy: "value",
                label: "name",
                tLabel: 'components.tools.media_monitoring.name',
                multiple: false,
                checkboxes: true,
                closeOnSelect: true,
                showLabels: false,
                maxHeight: 250,
                placeholder: "Select Filter Set",
                tPlaceholder: 'components.tools.media_monitoring.select_filter_set',
                tagPlaceholder: "",
                allowEmpty: false
            },
            mandatory: true,
            class: "custom-cols-2",
            isSourceSpecific: true,
        },

        /**
          * @property
          * @name yearOfBirth - yearOfBirth filter data
          */
        yearOfBirth: {
            label: "Year of birth",
            tLabel: 'components.tools.media_monitoring.year_of_birth',
            value: null,
            class: "w-1/3",
            isSourceSpecific: true,
            props: {
                searchable: true,
                options: [],
                checkboxes: true,
                closeOnSelect: true,
                showLabels: false,
                maxHeight: 250,
                placeholder: "Select Year",
                tPlaceholder: 'components.tools.media_monitoring.select_year',
                tagPlaceholder: "",
            },
        },
        filterOptionsMaster: {
            eventEntityRisks: [],
            eventsSummary: [],
            languages: [],
            matchNames: [],
            matchesSummary: [], 
            publisherCountries: [], 
            publisherRegions: [], 
            publisherSubRegions: [],
            territories: []
        },
        monthOptions: [],
        dayOptions: [],
        yearOfBirthOptions: [],
        countriesOptions: [],
        stateOptions: [],
        filterOptions: [],
        isSavedLoading: {
            loading: false,
            loadingCardIndex: null,
        },
        isBulkMonntoringLoading: false,
        savedFilter: "all",
        request_id: null,
        sigma_request_id: null,
        sigmaUrn: null,
        isExpandedLoaded: false,
        perPageOptions: [10, 20, 50, 100],
        appliedFilterCount: 0,
        filters: {
            saved: "all",
            monitoring: "all",
        },
        filteredSources: {},
        prevAppliedFilters: {
            monitoring: "all",
            saved: "all",
            searchQuery: "",
            filterJurisdiction: [],
        },
        isBulkMonitorOn: false,
        latestVersionTotalResults: 0,
        timeline: [],
        offset: 0,
        isFilterApplied: false,
        case_id: "",
        isComparisonModeOn: false,
        searchInput: "",
        start_time: "",
        end_time: "",
    }),
    computed: {
        ...mapGetters([
            "getNoMatchesFlag", 
            "searchedQueries",
            "getUserFeatures",
            "getSelectedEntity",
            "getNeoCaseId",
            "getProduct",
            "getResearchData",
            "getAllToolsData",
            "getActiveCaseId",
            "getCaseNames",
            "getSocialPlatforms",
            "getPermissions",
            "checkPermissionsFetched",
            "getSelectedToolQuery",
            "getMonitoringDateFilter",
            "getAllMonitoringData",
            "getToolsFilterData",
            "nerFilters",
            "getAutoPopulatedCountryList",
            "getAdverseFilteredResults",
            "getCheckDescription",
        ]),
        tabsStatusList() {
            return this.tabsStatus?.list.map(i=>({
                ...i,
                label: this.$t(`components.light_ray.${i?.label}`?.toLowerCase())
            })) || []
        },
        getResultsTitle() {
            let resultsTitle = this.searchKeyword;
            if (checkPermission('checkOutput.source_name')) resultsTitle += `(mediamonitoring)`
            return resultsTitle;
            // let resultsTitle = this.searchKeyword;
            // resultsTitle += `(mediamonitoring)`
            // return resultsTitle;
        }, 
        adverseFilteredResults: {
            get() {
                return this.getAdverseFilteredResults;
            },
            set(val) {
                this.SET_ADVERSE_FILTERED_RESULTS(val);
            },
        },
        getHeight() {
            let card = document.getElementById("case-list")?.scrollHeight;
            let tabs = document.getElementById("dashboard-tabs")?.scrollHeight || 0;
            let header = document.getElementById("disclaimer")?.offsetHeight || 0;
            if (header && card) {
                return `height:${card - (tabs + header)}px`;
            } else return `height:100%`;
        },
        
        formattedDate() {
            let formatDate = [];
            if (this.dateRange?.length) {
                let start = this.dateRange[0];
                start = DateTime.fromMillis(start);
                start = start.toFormat("dd/MM/yyyy");
                let end = this.dateRange[1];
                end = DateTime.fromMillis(end);
                end = end.toFormat("dd/MM/yyyy");
                formatDate = [start, end];
            }
            return formatDate;  
        },

        formattedPublicationDate() {
            let formatDate = [];
            if (this.filterPublicationDate?.length) {
                let start = this.filterPublicationDate[0];
                start = DateTime.fromMillis(start);
                start = start.toFormat("dd/MM/yyyy");
                let end = this.filterPublicationDate[1];
                end = DateTime.fromMillis(end);
                end = end.toFormat("dd/MM/yyyy");
                formatDate = [start, end];
            }
            return formatDate;  
        },

        getHiddenTabs() {
            return this.isCaseCreated ? [] : mediaMonitoringTabs.hiddenTabs
        },
        getTimelineData() {
            return this.timeline
        },
        isMonitoringAllowed() {
            return this.getUserFeatures.includes("sigma__create_monitoring_entity")
        },
        bulkUploadAuth() {
            return false
        },
        csvData() {
            return this.convertToCSV(this.adverseResultsList);
        },
        searchQueryExists() {
            let flag = true;
            // if (this.toolSearchQueries.findIndex((el) => el._id === this.getSelectedToolQuery?.query_id) < 0) flag = false;
            return flag;
        },
        allCount(){
            return this.adverseResults.length == 100 ? this.totalRecordsInAllQueries : this.adverseResults.length 
        },
        selectedQuery() {
            var findData = this.searchedQueries.filter(x => x.tool == "sigma-tool").find((data) => data?.query.entity_name === this.selectedItem?.value);
            if (!findData) return null;

            let maskedQuery = this.viewQuery(findData);
            findData.query_payload = {
                query_id: findData?._id,
                query_string: maskedQuery,
                search_string: maskedQuery,
            };
            return findData
        },
        
        /**
         * @property
         * @name csvFields
         * @return {Array} - return list of fields to be downloaded in csv
         */
        csvFields() {
            return ["name", "aka_names", "types", "entity_type", "dob", "locations"];
        },
        csvLabels() {
            return {
                name: this.$t('components.tools.media_monitoring.name'),
                aka_names: this.$t('components.tools.media_monitoring.aka_names'),
                types: this.$t('components.tools.media_monitoring.types'),
                entity_type: this.$t('components.tools.media_monitoring.entity_type'),
                dob: this.$t('components.tools.media_monitoring.dob'),
                locations: this.$t('components.tools.media_monitoring.locations')
            }
        },

        uploadUrl() {
            return `osint-tools/search/bulk-upload`;
        },

        /**
         * @property
         * @name expandedCard
         * @return {Object} - return data for the selected card
         */
        expandedCard() {
            return this.adverseFilteredResults[this.selectedResultCard]?.api_all_data ?? {};
        },
        /**
         * @property
         * @name adverseResultsList
         * @return {Array} - return list of all search results after applying filters
         */
        adverseResultsList() {
            return this.adverseFilteredResults;
        },
        
        
        getPublisherCountries() {
            return this.filterOptionsMaster?.publisherCountries?.map((el) => ({
                value: el,
                label: this.countriesOptions?.[0]?.categories.find((country) => country.alpha_2_code.toLowerCase() === el)?.name || el
            }))
        },
        
        getPublisherLanguages() {
            return this.filterOptionsMaster?.languages?.map((el) => ({
                value: el,
                label: el === "en" ? "English": this.countriesOptions?.[0]?.categories.find((country) => country.alpha_2_code.toLowerCase() === el)?.name || el,
            }))
        },
        
        getPublisherMentions() {
            return this.filterOptionsMaster?.territories?.map((el) => ({
                value: el,
                label: el.includes("US-") ? 
                    this.stateOptions?.[0]?.categories.find((country) => country.alpha_2_code === el?.split("US-")?.[1])?.name || el:
                    this.countriesOptions?.[0]?.categories.find((country) => country.alpha_2_code === el)?.name || el
            }))
        },


        /**
         * @property
         * @name getTotalPages
         * @return {Number} - return number of total pages of search results
         */
        getTotalPages() {
            if (this.tabsStatus.selected === 'all' || this.tabsStatus.selected === 'unknown')
                return Math.ceil(this.cardStatusResults.length / this.items_count);
            else return Math.ceil(this.cardStatusCounts?.[`${this.tabsStatus.selected}Count`] / this.items_count);
        },

        getRiskTypes() {
            let results = [];
            this.adverseResults.forEach((res)=>{
                if (res.api_all_data?.data?.RiskTag?.length) {
                    res.api_all_data?.data?.RiskTag?.forEach((tag)=>{
                        if (!results.map((res)=>res.value).includes(tag)) {
                            results.push({
                               value: tag
                            });
                        }
                    })
                }
            })
            return [{group: "Risk Type", tGroup: this.$t("components.tools.media_monitoring.risk_type"), categories: results}] },

        /**
         * @property
         * @name getEntityTypes
         * @return {Array} - return list of entity types (output filters)
         */
        getEntityTypes() {
            let results = [];
            this.adverseResults?.map((e) => {
                if (e.key === "mediaMonitoring") {
                    if (!results.some((res) => res.value === "individual"))
                        results.push({
                            value: "individual",
                            tLabel: this.$t("integrated_checks.individual"),
                            source: e?.key,
                        });
                    if (!results.some((res) => res.value === "business"))
                        results.push({
                            value: "business",
                            tLabel: this.$t("integrated_checks.business"),
                            source: e?.key,
                        });
                } else if (e?.entity_type && !results.some((res) => res.value === e?.entity_type?.toLowerCase()))
                    results.push({
                        value: e?.entity_type?.toLowerCase(),
                        source: e?.key,
                    });
            });
            return [{group: "Entity Type", tGroup: this.$t("components.tools.media_monitoring.entity_type"), categories: results}]; 
        },

        /**
         * @property
         * @name getFilterJurisdiction
         * @return {Array} - return list of jurisdiction (output filters)
         */

        getFilterJurisdiction() {
            let countries = new Set();
            this.adverseResults?.forEach((result) => {
                countries.add(result?.api_all_data.data.Country)
            });
            // || field.toLowerCase() === 'countries' ||field.toLowerCase() === 'country'
            let data = Array.from(countries);

            return [{group: "Jurisdiction", tGroup:  this.$t("components.tools.media_monitoring.jurisdiction"), categories: data.sort((a, b) => a.localeCompare(b))?.filter((el) => el)}]; 
        },

        /**
         * @property
         * @name isMonitoringTab
         * @return {Boolean} - check if monitoring tab is selected
         */

        isMonitoringTab() {
            return this.$route.name === "monitoring";
        },

        /**
         * @property
         * @name checkMarkAllDone
         * @return {Boolean} - Monitoring - check if all results have been marked done or not
         */
        checkMarkAllDone() {
            // let result = [];
            // result = this.adverseFilteredResults;
           
            // result = result.slice(this.items_count * (this.page_number - 1), this.page_number * this.items_count);
            // if (result && result.length) {
            //     return result.filter((res) => res?.name?.toLowerCase().includes(searchKeyword)).every((res) => res.api_all_data.data.changes_viewed);
            if (this.adverseFilteredResults && this.adverseFilteredResults.length) {
                return this.adverseFilteredResults.every((res) => res.api_all_data.data.changes_viewed);
            } else {
                return false;
            }
        },

        /**
         * @property
         * @name checkBulkToggleOn
         * @return {Boolean} - Monitoring - check if all results have toggle monitoring on or off
         */

        checkBulkToggleOn() {
            let searchedResultList = [];
            searchedResultList = this.adverseResultsList;
            if (searchedResultList && searchedResultList.length) {
                this.isBulkMonitorOn = searchedResultList.every((result) => result.api_all_data.data.monitoring_status);
                return searchedResultList.every((result) => result.api_all_data.data.monitoring_status);
            } else return false;
        },

        /**
         * @property
         * @name isSearchBtnDisabled
         * @return {Boolean} - check if search button is disabled
         */
        isSearchBtnDisabled() {
            const dateType = this.allSources["mediaMonitoring"].filterSections?.[0]?.filters?.find((el) => el.key === 'dateType');
            const dateRangeFilter = this.allSources["mediaMonitoring"].filterSections?.[0]?.filters?.find((el) => el.key === 'dateRangeFilter');
            const filter_id = this.allSources["mediaMonitoring"].filterSections?.[1]?.filters?.find((el) => el.key === 'filter_id');
            if (
                !this.isAllRunQueries &&
                (!this.selectedItem?.value || !filter_id?.value?.length || (dateType?.value?.value === 'custom' && !dateRangeFilter?.value?.length)) 
            ) 
                return true;
            else return false;
        },

        allSourcesChecked() {
            let allSourcesChecked = true;
            for (let source in this.allSources) {
                if (!this.allSources[source].isChecked) {
                    allSourcesChecked = false;
                    break;
                }
            }
            return allSourcesChecked;
        },
        last_run_date() {
            const querySource = this.autorun ? this.selectedQuery : this.getSelectedToolQuery?.query;
            return querySource?.last_runtime;
        },
        isEnabledApplyButton() {           
            let appliedFilters = {
                monitoring:this.selectedDataType.value,
                searchQuery: this.searchQuery,
                filterMatchedEntity: this.filterMatchedEntity,
                filterRiskType: this.filterRiskType,
                filterEntityRisk: this.filterEntityRisk,
                filterPublicationDate: this.filterPublicationDate,
                filterPublisherCountry: this.filterPublisherCountry,
                filterPublisherRegion: this.filterPublisherRegion,
                filterPublisherSubRegion: this.filterPublisherSubRegion,
                filterMentions: this.filterMentions,
                filterLanguages: this.filterLanguages

            };
            return isEqual(appliedFilters, this.prevAppliedFilters);
        },

        sourceBody() {
            let body = {
                entity_type: this.entityType,
                entity_name: this.selectedItem?.value ?? "",
                // customer_key: this.$route?.query?.caseid,
                customer_key: `${this.getNeoCaseId}-${this.getSelectedEntity.id}`,
                // group_ids: [this.$route?.query?.caseid],
                group_ids: [20726],
                sources: ["sigma"],
            };

            for (const si in this.allSources["mediaMonitoring"].filterSections) {
                const section = this.allSources["mediaMonitoring"].filterSections[si];
                for (const fi in section.filters) {
                    const filter = section.filters[fi];
                    if (filter.key === "dob" && filter.drops.some((drop) => drop.value)) {
                        if ( !(['any', 'person'].includes(body.entity_type))) return;
                        let dob = {
                            birth_year: filter.drops?.[2]?.value?.toString(),
                            birth_month: filter.drops?.[1]?.value ? (filter.drops?.[1]?.props?.options?.findIndex((idx) => idx === filter.drops?.[1]?.value) + 1)?.toString()?.padStart(2, "0") : "",
                            birth_day: filter.drops?.[0]?.value?.toString()?.padStart(2, "0") ?? "",
                        }
                        
                        body = {
                            ...body,
                            dob: dob.birth_year + "-" + dob.birth_month + "-" + dob.birth_day,
                        };
                    } else if (filter.props && filter.props.options && filter.value && filter.key !== 'dateType') {
                        if (filter.props.multiple)
                            body = {
                                ...body,
                                [filter.key]: filter.value.map((val) => val.value),
                            };
                        else if (filter.key === 'filter_id')
                            body = {
                                ...body,
                                [filter.key]: filter.value?.[0]?.value,
                            };
                        else
                            body = {
                                ...body,
                                [filter.key]: filter.value.value,
                            };
                    } else if (filter.type === "string" && filter.value) {
                        if (filter.key === 'aliases')
                            body = {
                                ...body,
                                [filter.key]: filter.value?.split(','),
                            };
                        else
                            body = {
                                ...body,
                                [filter.key]: filter.value,
                            };
                    }  else if (filter.key === 'dateRangeFilter' && filter?.value?.length) {
                        let start_date = new Date(filter?.value?.[0]).toISOString();
                        start_date = DateTime.fromISO(start_date).startOf('day').toFormat("yyyy-MM-dd'T'hh:mm:ss.SSS'Z'");

                        let end_date = new Date(filter?.value?.[1]).toISOString();
                        end_date = DateTime.fromISO(end_date).endOf('day').toFormat("yyyy-MM-dd'T'hh:mm:ss.SSS'Z'");

                        body = {
                            ...body,
                            start_time: this.start_time || start_date,
                            end_time: this.end_time || end_date,
                        };
                    }  else if (filter.props && filter.props.options && filter.value?.value && filter.key === 'dateType') {
                        const minus_days = {
                            "past_24_hrs": 1,
                            "past_week": 7,
                            "past_month": 30,
                            "past_year": 365,
                        };
                        let start_date = new Date().toISOString();
                        start_date = DateTime.fromISO(start_date).minus({ days: minus_days?.[filter?.value?.value] }).startOf('day').toFormat("yyyy-MM-dd'T'hh:mm:ss.SSS'Z'");

                        let end_date = new Date().toISOString();
                        end_date = DateTime.fromISO(end_date).endOf('day').toFormat("yyyy-MM-dd'T'hh:mm:ss.SSS'Z'");

                        body = {
                            ...body,
                            [filter.key]: filter.value?.value,
                            start_time: this.start_time || start_date,
                            end_time: this.end_time || end_date,
                        };
                    } 
                }
            }
            return body;
        },
        prebuiltQueryPayload() {
            let data = {
                ...this.prebuiltQuery,
            };

            if (this.prebuiltQuery?.countries) {
                data = {
                    ...data,
                    coumtries:  this.countriesOptions?.[0]?.categories?.filter((el) => 
                        el.alpha_2_code === this.prebuiltQuery.countries || el.alpha_3_code === this.prebuiltQuery.countries
                    )?.map((el) => el.alpha_2_code), 
                }
            }
            return data;
        },
    },
    watch: {
        showResult() {
            this.$el.scroll(0, 0);
        },
        // "$route.query.q"() {
        //     if (this.triggerRoute) {
        //         this.redirectToQuery();
        //     }
        // },
    },
    inject: {
        isCase: { default: false }
    },
    created() {
        if (this.autorun) this.startLoader("nameSearch");
        EventBus.$on("handleDone", async (data) => {
            let result = cloneDeep(this.adverseFilteredResults);
            if (!data.oldVersion) {
                let index = result.findIndex((el) => el.curr_index === data.curr_index);
                if (index > -1) {
                    result[index] = data.card;
                    this.adverseFilteredResults = result;
                    // this.checkMarkAllDone()
                }
            } else {
                let oldVersionResults = cloneDeep(this.timeline);
                let index = oldVersionResults.findIndex((el) => el.curr_index === data.curr_index);
                if (index > -1) {
                    oldVersionResults[index] = data.card;
                    this.timeline = oldVersionResults;
                    // this.checkMarkAllDone()
                }
            }
            // await this.filterData();
            this.$emit("refreshQueries");
            this.$forceUpdate();
        });
        EventBus.$on("handleResultSave", (data) => {
            // API Call to save card
            this.handleSavedCard(data);
        });

        EventBus.$on("showMoreData", (data) => {
            this.expandResult(data);
        });
    },
    async mounted() {
        this.SET_QUERIES_LOADER(true);
        if (this.isMonitoringAllowed) {
            await this.setMonitoring()
        } else {
            await this.setMonitoring(true)
        }
        
        this.setDefaultFilters()
        this.case_id = this.getNeoCaseId;
        this.tabName = this.$route.name;
        this.$emit("updateQueryTotal", { checkName: this.$route.query.check_name })
        this.$emit("getQueriesMonitoring")
        await this.getToolData();
        await this.fetchAllJuridictions();
        await this.fetchFilterSet();
        this.fillYears();
        this.dateType.props.options = this.dateType.props.options.map((opt) => ({
            ...opt,
            name: this.$t(`components.tools.media_monitoring.dateTypeOptions.${opt.value}`),
        }));
        
        this.dateType.value = {
            ...this.dateType.value,
            name: this.$t(`components.tools.media_monitoring.dateTypeOptions.${this.dateType.value.value}`),
        };

        
        await this.initalizeData();
        this.setToolsFilterData(this.filters);
        // await this.updateEventCount();

        if (this.isCase) {
            this.setAutoPopulateValue();
        }

        const entityName = this.prebuiltQueryPayload?.name || this.getSelectedEntity?.entity_name;

        this.selectedItem = {
            value: entityName,
        };
        this.searchKeyword = entityName;
        await this.mapInputFilters()
        this.setExpandSection();
        await this.getToolsStatus();
        if (this.autorun) {
            await this.autoInit();
        } else if (this.toolSearchQueries?.length) { 
            this.$emit("selectAllQueries");
        }
        
        await this.getSavedQueryList();
        this.SET_QUERIES_LOADER(false);
    },
    beforeDestroy() {
        this.SET_ADVERSE_FILTERED_RESULTS([]);

        this.setToolsData("sigma-tool");

        EventBus.$off("handleDone");
        EventBus.$off("handleResultSave");
        EventBus.$off("showMoreData");
    },
    methods: {
        ...mapMutations([
            "SET_ALL_TOOLS_DATA",
            "SET_MONITORING_DATE_FILTERS",
            "SET_ALL_MONITORING_DATA",
            "SET_QUERIES_LOADER",
            "SET_ADVERSE_FILTERED_RESULTS",
        ]),
        ...mapActions(["getAllCaseNames", "setToolsFilterData", "getToolsStatus", "refreshCheckToolSelfStatus", "setQueryResultLoader"]),
        checkPermission,

        async getQueryPayload(requestBody, source) {
            if (!this.autorun) return requestBody;
            
            const { data } = await mainAxios.post("/tenant-check/search-query", {
                "query": requestBody,
                "entity_type_id": this.entityTypeId,
                "source": source
            });
            return data?.query || requestBody;
        },
        async afterSearchResponseReceived({ searchResults = [] }) {
            const { case_id, id } = this.getSelectedEntity;

            try {
                await this.refreshCheckToolSelfStatus({
                    caseId: case_id,
                    entityId: id,
                    checkId: this.resolvedCheckId,
                    searchResults,
                    options: {
                        refreshCheckStatus: this.autorun ? true : false
                    }
                });
            } catch {
                console.error('error::afterSearchResponseReceived')
            }
        },
        async updateEventCount() {
            const payload = {
                minDate: this.dateFilters.minDate,
                maxDate: this.dateFilters.maxDate,
                tool: this.$route.query.check_name || this.autorun?.headers['x-tool-name'],
            }
            await this.getQueryMonitoringEvents(payload)
        },
       
        setDefaultFilters() {
            this.allFilters = [];
           
            let startDt = new Date();
            let endDt;
            endDt = new Date(startDt.getTime() - 30 * 24 * 60 * 60 * 1000);
            Object.assign(this.dateFilters, {
                minDate: DateTime.fromISO(startDt).endOf('day'),
                maxDate: endDt,
            });
            let dates = [endDt, startDt];
            this.dateRange = dates.map((e) => Date.parse(e));
            this.selectedDataType = {label: "All Results", value: "all_results"}
        },
        
        setExpandSection() {
            for (let source in this.allSources) {
                if (source === "mediaMonitoring") {
                    this.allSources[source].filterSections.forEach(section => {
                        section.expanded = false;
                        section.filters.some(filter => {
                            if (filter.type === 'string' && filter.value !== '') {
                                section.expanded = true;
                                return true;
                            }
                            if (filter.type === 'datepicker' && filter.value && filter.value.length !== 0) {
                                section.expanded = true;
                                return true;
                            }   
                            if (filter.props?.options && filter.value && filter.value.length !== 0) {
                                section.expanded = true;
                                return true; 
                            }
                            if (filter.drops?.length && filter.drops.some((drop) => drop.value)) {
                                section.expanded = true;
                                return true; 
                            }
                            return false;
                        });
                    });
                }
            }
        },
        setAutoPopulateValue(){
            const systemFieldsData = this.$store.getters.getSystemFields;
            // DOB
            if(systemFieldsData['date_of_birth'] && systemFieldsData['date_of_birth'].length) {
                let month =  systemFieldsData['date_of_birth'][0]?.split("-")[1];
                month = Number(month, 10);
                this.dob.drops[2].value = systemFieldsData['date_of_birth'][0].split("-")[0];
                this.dob.drops[1].value = this.monthOptions[month-1];
                this.dob.drops[0].value = systemFieldsData['date_of_birth'][0].split("-")[2];
            }
        },
        getMappingValue(data_values = [], source, mapValues, tag) {
            const result_dict = data_values.map((ele) => {
                let list = Object.entries(mapValues);
                const result = list.reduce((accumulator, item) => {
                    let keys = item[1][source].keys;
                    let separator = item[1][source].separator;
                    accumulator[item[0]] = keys
                        .map((key) => {
                            //Iterating inside array for fetching the values in "iterable_key"
                            if (item[1][source].iterable_key) {
                                return get(ele, key, []).map((el1) => get(el1, item[1][source].iterable_key, ""));
                            }
                            if (typeof item[1][source] === "object") {
                                return get(ele, key, []);
                            }
                            return get(ele, key, "N/A");
                        })
                        .filter((e) => e != null && e != "")
                        .join(separator ? separator : ", ");
                    return accumulator;
                }, {});
                result.key = source;
                result.sourceTag = tag;
                return {...result, api_all_data: ele};
            });
            return result_dict;
        },
        convertToCSV(arr) {
            return convertToCSV(arr);
        },
        csvFileName(query) {
            return csvFileName('mediaMonitoring', query, 'mediaMonitoring');
        },
        setCardStatusCounts() {
            if(this.isAllRunQueries){
                this.cardStatusCounts.all = this.totalRecordsInAllQueries
                this.cardStatusCounts.confirmedCount = this.totalStatusCount.CONFIRMED
                this.cardStatusCounts.unknownCount = this.totalStatusCount.UNKNOWN
                this.cardStatusCounts.potentialCount = this.totalStatusCount.POTENTIAL
                this.cardStatusCounts.irrelevantCount  = this.totalStatusCount.IRRELEVANT
            }
            else{
                this.cardStatusCounts.all = this.totalCount
                this.cardStatusCounts.confirmedCount= this.cardStatusResults.filter((res) => res.card_status ==='CONFIRMED').length,
                this.cardStatusCounts.unknownCount= this.cardStatusResults.filter((res) => res.card_status ==='UNKNOWN' || !res.card_status).length,
                this.cardStatusCounts.potentialCount= this.cardStatusResults.filter((res) => res.card_status ==='POTENTIAL').length,
                this.cardStatusCounts.irrelevantCount=  this.cardStatusResults.filter((res) => res.card_status ==='IRRELEVANT').length
            }
        },
        async updateCardStatus() {
            await this.getAllCardsDetails();
            this.applyRiskFilters(this.tabsStatus.selected);
            this.setCardStatusCounts()
            if (this.page_number > this.getTotalPages)
                this.page_number = this.getTotalPages;
        },

        async handleRedactCard() {
            this.adverseFilteredResults = this.adverseFilteredResults.map((el) =>
                el.api_all_data.data.doc_id === this.expandedResultCard.api_all_data.data.doc_id ? {
                    ...el,
                    api_all_data: {
                        ...el.api_all_data,
                        ...this.expandedResultCard.api_all_data,
                    }
                } : el
            );
            this.cardStatusResults = this.adverseFilteredResults;
            await this.getAllCardsDetails();
        },

        async updateTabCount(){
            if(this.isAllRunQueries){
                this.isNextPag = true;
                await this.onRunAllQueries(null, "adverseResults");
                this.setCardStatusCounts()
            }
            else{
                await this.updateCardStatus();
            }
        },
        async getAllCardsDetails() {
            const payload = {
                case_id: this.getNeoCaseId,
                tool_name: this.$route.query.check_name || this.autorun?.headers['x-tool-name'],
                entity_id: this.$route.query.entityId
            }
            if (!this.isAllRunQueries) payload["query_id"] = this.$route.query.query_id;
            const url = '/service/card-results'
            const {data} = await mainAxios.post(url, payload)
            if (data?.data.length > 0) {
                data.data.forEach((res)=>{
                    this.cardDetailsMap[res.card_id] = res
                })
            }
            this.mapCardResultsData()
        },
        mapCardResultsData() {
            this.cardStatusResults.forEach((res)=> {
                res.card_status = this.cardDetailsMap[res.api_all_data.data.doc_id] && this.cardDetailsMap[res.api_all_data.data.doc_id].status !== 'None' ? 
                    this.cardDetailsMap[res.api_all_data.data.doc_id].status : 'UNKNOWN'
                res.customer_notes =  this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id].customer_notes : ''
                res.research_notes =  this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id].notes : ''
                res.risk_categories = this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id].risk_categories : []
                res.bespoke = this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id]?.bespoke : []
                res.entity_status = this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id]?.entity_status : 'Red',
                res.screenshot = this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id]?.screenshot : {}
            })
            this.adverseFilteredResults.forEach((res) => {
                res.card_status = this.cardDetailsMap[res.api_all_data.data.doc_id] && this.cardDetailsMap[res.api_all_data.data.doc_id].status !== 'None' ? 
                    this.cardDetailsMap[res.api_all_data.data.doc_id].status : 'UNKNOWN'
                res.customer_notes =  this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id].customer_notes : ''
                res.research_notes =  this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id].notes : ''
                res.risk_categories = this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id].risk_categories : []
                res.bespoke = this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id]?.bespoke : []
                res.entity_status = this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id]?.entity_status : 'Red',
                res.screenshot = this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id]?.screenshot : {}
            })
            this.timeline.forEach((res)=>{
                res.card_status = this.cardDetailsMap[res.api_all_data.data.doc_id] && this.cardDetailsMap[res.api_all_data.data.doc_id].status!='None'  ? this.cardDetailsMap[res.api_all_data.data.doc_id].status : 'UNKNOWN'
                res.customer_notes =  this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id].customer_notes : ''
                res.research_notes =  this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id].notes : ''
                res.risk_categories = this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id].risk_categories : []
                res.bespoke = this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id]?.bespoke : []
                res.entity_status = this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id]?.entity_status : 'Red'
                res.screenshot = this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id]?.screenshot : {}
            })
            this.timeline = cloneDeep(this.timeline)
            this.adverseFilteredResults = cloneDeep(this.adverseFilteredResults)
            this.setCardStatusCounts()

        },
        async selectToolsCardStatus(_, id) {
             if (this.tabsStatus.selected === id) return; 
            // this.filterData();
            this.tabsStatus.selected = id;
            if (this.isAllRunQueries) {
                this.isNextPag = true;
                this.offsetPag = 0;
                this.limitPag = 1;
                await this.onRunAllQueries(null, "adverseResults");
                this.isNextPag = false;
                this.setCardStatusCounts();
            }
            this.page_number = 1;
            this.applyRiskFilters(id);
            this.closeExpandedResult();
        },

        applyRiskFilters(id) {
            this.mapCardResultsData();
            if (id === "all") {
                this.adverseFilteredResults = this.cardStatusResults
            } else if (id === "unknown") {
                this.adverseFilteredResults = this.cardStatusResults.filter((res) => res.card_status?.toLowerCase() === id || !res.card_status)
            } else {
                this.adverseFilteredResults = this.cardStatusResults.filter((res) => res.card_status && res.card_status.toLowerCase() === id)
            }
            this.adverseFilteredResults = this.adverseFilteredResults
                .filter(item => item.api_all_data?.data?.doc_id) // Remove entries with no doc_id
                .filter((item, index, self) =>
                    index === self.findIndex(t => t.api_all_data.data.doc_id === item.api_all_data.data.doc_id)
                );
            this.adverseFilteredResults = this.adverseFilteredResults.map((ele, index) => ({...ele, current_index: index}));
            this.setCardStatusCounts()
        },

        handleStatusUpdate() {
        },

        async getToolData() {
            const companies = await this.getDropdownData("company_name");
            const persons = await this.getDropdownData("name");
            this.nameSearches = [
                {
                    group: "Entities",
                    tGroup: this.$t("components.tools.media_monitoring.entities"),
                    categories: companies.concat(persons),
                }, // list-in-methods
            ];
        },
        // fetchSource(key) {},
        onToggle() {
            this.open = !this.open;
        },
        handleOutside() {
            this.open = false;
        },

        async handleSavedCard(cardData) {
            this.isSavedLoading = {
                loading: true,
                loadingCardIndex: cardData.api_all_data.data.doc_id,
            };
            let sources = [];
            if (cardData.key === "mediaMonitoring") sources.push("sigma");
            else sources.push(cardData.key.toLowerCase());
            let payload = {
                sources: sources,
                doc_id: cardData.api_all_data?.data?.doc_id,
                saved: !cardData.api_all_data.data.saved,
                card_data: {
                    created_at: cardData?.created_at ?? null,
                    updated_at: cardData?.updated_at ?? null,
                    case_id: this.case_id,
                    query_id: this.sigma_request_id,
                    tool: "tool-adverse-meta",
                    tool_name: this.$route.params.toolName,
                },
            };
            let url = `/osint-tools/card/mark-as-saved`;
            try {
                const {data} = await mainAxios.post(url, payload);
                if (data.success === true) {
                    let result = cloneDeep(this.adverseResults);
                    let elementIndex = result.findIndex((obj) => obj.api_all_data.data.doc_id === cardData.api_all_data.data.doc_id);
                    let resultSavedElement = result[elementIndex];
                    let expandedResult = this.expandedResultCard;
                    resultSavedElement.api_all_data.data.saved = !resultSavedElement.api_all_data.data.saved;
                    if (expandedResult && expandedResult.api_all_data.data.doc_id === cardData.api_all_data.data.doc_id) {
                        expandedResult.api_all_data.data.saved = !expandedResult.api_all_data.data.saved;
                        this.expandedResultCard = expandedResult;
                    }
                    result.splice(elementIndex, 1, resultSavedElement);
                    this.adverseResults = result;
                    this.isSavedLoading = {
                        loading: false,
                        loadingCardIndex: null,
                    };
                    this.$toast.success(this.$t('components.tools.media_monitoring.updated'));
                    await this.filterData();
                    this.$emit('getQueriesMonitoring')
                    this.$forceUpdate();
                }
            } catch {
                this.$toast.warning(this.$t('components.tools.media_monitoring.please_try_again_after_sometime'));
                this.isSavedLoading = {
                    loading: false,
                    loadingCardIndex: null,
                };
            }
        },
        async getDropdownData(field) {
            let data = this.toolData.filter((user) => user.val_type === field);
            return data;
        },

        handleChecked(data) {
            let allChecked = false;
            const allList = [...this.nameSearches[0]?.categories];
            this.$emit("updateToolData", "sigma", allList, data);
            allChecked = allList?.length ? (allList.findIndex((n) => !n.visited) > -1 ? false : true) : false;
            this.$emit("handleChecked", allChecked);
        },

        startLoader(section) {
            this.loaderController[section].success = false;
            this.loaderController[section].loading = true;
        },
        successLoader(section) {
            this.loaderController[section].success = true;
            this.loaderController[section].loading = false;
        },
        resetLoader(section) {
            this.loaderController[section].success = false;
            this.loaderController[section].loading = false;
        },
        /**
         * @function
         * @name expandResult
         * @params {result, index, i} - result - selected card data
         *                            - index - selected card index
         */
        async expandResult(result) {
            const index = result.index;
            const isOldVersion = result.isOldVersion;
            this.isExpandedLoaded = true;
            let detailsExpanded = true;
            if (result.detailsExpanded === false) detailsExpanded = false;

            if (detailsExpanded) {
                this.selectedResultCard = index;
                if (isOldVersion) {
                    this.timeline[index] = result;
                    this.isOldVersionSelected = true;
                } else {
                    this.adverseResults[index] = result;
                    this.isOldVersionSelected = false;
                }
                this.expandedResultCard = result;
                this.isResultExpanded = true;
                this.isComparisonModeOn = false;
                this.$emit("searchResult", {data: this.adverseResults, source: "sigma", searchType: "name"});
                if (result.expanded == undefined) result.expanded = true;
                else {
                    result.expanded = !result.expanded;
                }
                this.$forceUpdate();
                const resultContainer = document.getElementById(`result-expanded`);
                if (resultContainer) {
                    resultContainer.scrollTo({
                        top: 1,
                        behavior: "smooth",
                    });
                    // document.getElementById(`result-${index}`).scrollIntoViewIfNeeded(true);
                }
                this.isExpandedLoaded = false;
            } else {
                this.isComparisonModeOn = true;
                this.updateComparisonReferences(result);
            }
        },

        /**
         * @function
         * @name handleSourceChange
         * @params {e} - pointer event for source input checkbox (Media Monitoring)
         */
        handleSourceChange(e) {
            if (this.sources.includes(e.target.value)) {
                const filterSource = this.sources.filter((el) => el !== e.target.value);
                this.sources = filterSource;
            } else {
                this.sources.push(e.target.value);
            }

            for (let source in this.allSources) {
                if (this.allSources[source].value === e.target.value) {
                    this.allSources[source].isChecked = !this.allSources[source].isChecked;
                    break;
                }
            }
        },
        /**
         * @function
         * @name handleSourceExpand
         * @params {source, value} - source & value (Media Monitoring)
         */
        handleSourceExpand(source, value, toggle) {
            if (toggle) this.allSources[source].isChecked = !this.allSources[source].isChecked;
            if (this.sources.includes(value)) {
                const filterSource = this.sources.filter((el) => el !== value);
                this.sources = filterSource;
            } else {
                this.sources.push(value);
            }
        },

        /**
         * @function
         * @name updateSource
         * @params {e} - pointer event for source input checkbox (Media Monitoring)
         */
        updateSource(e, source) {
            if (e.target.checked && this.allSources[source].filterSections && this.allSources[source].filterSections.length) {
                this.allSources[source].isModalVisible = true;
            } else {
                this.handleSourceChange(e);
            }
            // this.manualSearch();
        },

        /**
         * @function
         * @name applyFilter - apply all filters
         */
        applyFilters(source, value) {
            if (!this.sources.includes(value)) this.sources.push(value);
        },

        /**
         * @function
         * @name closeFilter - close filters popup
         */
        closeFilter(source, value) {
            if (this.allSources[source].isChecked && !this.sources.includes(value)) this.allSources[source].isChecked = false;
        },

        /**
         * @function
         * @name filterData - filter Data as per the filters applied
         */
        async filterData() {
            this.appliedFilterCount = 0

            let allFilters = [
                "filterMatchedEntity",
                "filterRiskType",
                "filterEntityRisk",
                "filterPublicationDate",
                "filterPublisherCountry",
                "filterPublisherRegion",
                "filterPublisherSubRegion",
                "filterMentions",
                "filterLanguages"
            ];
            
            let that = this;
            this.allFilters = [];

            if (this.isFilterApplied) {
                for (let filter in allFilters) {
                    let filterValues = get(that, allFilters[filter]);
                    if ((typeof(filterValues) === 'string' && filterValues) || (typeof(filterValues) !== 'string' && filterValues?.length)) {
                        this.appliedFilterCount += 1;
                    
                        if (typeof(filterValues) === 'string' && filterValues) {
                            this.allFilters.push({
                                name: allFilters[filter],
                                value: filterValues,
                            });
                        } else if (allFilters[filter] === 'filterPublicationDate') {
                            this.allFilters.push({
                                name: allFilters[filter],
                                value: `${this.formattedPublicationDate?.[0]} - ${this.formattedPublicationDate?.[1]}`,
                            });
                        } else if (allFilters[filter] === 'filterRiskType') {
                            for (const value in filterValues) {
                                this.allFilters.push({
                                    name: allFilters[filter],
                                    value: filterValues[value].eventType,
                                });
                            }
                        } else {
                            for (const value in filterValues) {
                                this.allFilters.push({
                                    name: allFilters[filter],
                                    value: ["filterPublisherCountry", "filterMentions", "filterLanguages"].includes(allFilters[filter]) ? 
                                        filterValues[value].label : 
                                        filterValues[value],
                                });
                            }
                        }
                    }
                }
                
                if (this.monitoringActive) {
                    this.allFilters.push({name: "monitoring", value: this.selectedDataType.label})
                    this.appliedFilterCount += 1;

                    if (this.formattedDate?.length) {
                        this.allFilters.push({value:`${this.formattedDate[0]} To ${this.formattedDate[1]}`, name: "monitoringDateRange"})
                        this.appliedFilterCount += 1;
                    }
                }

                if (this.appliedFilterCount) {
                    this.startLoader("nameSearch");
                    this.redirectTo();

                    const headers = {
                        "x-tool-name": "sigma-tool",
                        "x-visited": true,
                        "x-refresh": false,
                        "x-status": 'RUNNING',
                        "x-entity-id": this.$route.query.entityId,
                        "x-case-id": this.getNeoCaseId,
                        "x-wlp-reference": process.env.VUE_APP_BACKEND_URL,
                        ...this.autorun?.headers,
                    }; 

                    let start_date, end_date;
                    if (this.filterPublicationDate?.length) {
                        start_date = new Date(this.filterPublicationDate?.[0]).toISOString();
                        start_date = DateTime.fromISO(start_date).startOf('day').toFormat("yyyy-MM-dd'T'hh:mm:ss.SSS'Z'");

                        end_date = new Date(this.filterPublicationDate?.[1]).toISOString();
                        end_date = DateTime.fromISO(end_date).endOf('day').toFormat("yyyy-MM-dd'T'hh:mm:ss.SSS'Z'");
                    } else if (this.allSources["mediaMonitoring"].filterSections[0].filters["dateRangeFilter"]?.value?.length) {
                        start_date = new Date(this.allSources["mediaMonitoring"].filterSections[0].filters["dateRangeFilter"]?.value?.[0]).toISOString();
                        start_date = DateTime.fromISO(start_date).startOf('day').toFormat("yyyy-MM-dd'T'hh:mm:ss.SSS'Z'");

                        end_date = new Date(this.allSources["mediaMonitoring"].filterSections[0].filters["dateRangeFilter"]?.value?.[1]).toISOString();
                        end_date = DateTime.fromISO(end_date).endOf('day').toFormat("yyyy-MM-dd'T'hh:mm:ss.SSS'Z'");
                    } else if (this.allSources["mediaMonitoring"].filterSections[0].filters["dateType"]?.value?.value) {
                        const minus_days = {
                            "past_24_hrs": 1,
                            "past_week": 7,
                            "past_month": 30,
                            "past_year": 365,
                        };
                        start_date = new Date().toISOString();
                        start_date = DateTime.fromISO(start_date).minus({ days: minus_days?.[this.allSources["mediaMonitoring"].filterSections[0].filters["dateType"]?.value?.value] }).startOf('day').toFormat("yyyy-MM-dd'T'hh:mm:ss.SSS'Z'");

                        end_date = new Date().toISOString();
                        end_date = DateTime.fromISO(end_date).endOf('day').toFormat("yyyy-MM-dd'T'hh:mm:ss.SSS'Z'");
                    }

                    let endDt, startDt;
                    if (this.dateRange?.length) {
                        startDt = new Date(this.dateRange?.[0]);
                        startDt.setHours(0);
                        startDt.setMinutes(0);
                        startDt.setSeconds(0);
                        startDt.setMilliseconds(0);
                        endDt = new Date(this.dateRange?.[1]);
                        startDt = DateTime.fromMillis(Date.parse(startDt));
                        startDt = startDt.toFormat("yyyy-MM-dd'T'hh:mm:ss.SSS'Z'");
                        endDt = DateTime.fromMillis(Date.parse(endDt)).endOf('day');
                        endDt = endDt.toFormat("yyyy-MM-dd'T'hh:mm:ss.SSS'Z'");
                    }


                    let reqBody = {
                        entity_risk: this.filterEntityRisk,
                        publisher_countries:  this.filterPublisherCountry.map((el) => el.value),
                        publisher_regions: this.filterPublisherRegion,
                        publisher_subregions: this.filterPublisherSubRegion,
                        mentions: this.filterMentions.map((el) => el.value),
                        language: this.filterLanguages.map((el) => el.value),
                        match_name: this.filterMatchedEntity?.length ? [this.filterMatchedEntity] : undefined,
                        risk_type: this.filterRiskType.map((el) => el.unformattedEventType),
                        start_time: start_date,
                        end_time: end_date,
                        all_queries: this.isAllRunQueries,
                        card_status: this.selectedDataType?.value,
                        start_range: startDt,
                        end_range: endDt,
                        additional_details: {
                            query_id: !this.isAllRunQueries ? this.sigma_request_id : undefined,
                            //   monitoring_status: true,
                            //   saved: true
                        },
                        urn: !this.isAllRunQueries ? this.sigmaUrn: undefined,
                    };
                    
                    const mediaMonitoring = await mainAxios.post("/service/sigma360/news/filters", reqBody, {
                        headers: headers,
                    })
                    if (mediaMonitoring) {
                        this.adverseResults = [];

                        await Promise.allSettled([mediaMonitoring])
                            .then(async (results) => {
                                let values = results.map((result) => result.value);
                                this.totalCount = values[0].data.data.length ;
                                this.showResult = true;
                                this.showSearch = false;
                                if (values[0].data.data.length > 0) {
                                    let mappingValue = this.getMappingValue(values[0].data.data, "mediaMonitoring", SIGMA_TOOL_MAPPING);
                                    mappingValue = mappingValue.map((media) => ({
                                        ...media,
                                        score: (media.score * 100)?.toFixed(2),
                                        api_all_data: {
                                            ...media.api_all_data,
                                            data: {
                                                ...media.api_all_data.data,
                                                articles: media.api_all_data.data.articles.map((article) => ({
                                                    ...article,
                                                    extractedTerritories: article.extractedTerritories.map((terr) => ({
                                                        ...terr,
                                                        country:  this.countriesOptions?.[0]?.categories?.find((el) => el.alpha_2_code === terr.country || el.alpha_3_code === terr.country)?.name || 
                                                            terr.country,
                                                        adminOne: this.stateOptions?.[0]?.categories?.find((el) => el.alpha_2_code === terr.adminOne || el.alpha_3_code === terr.adminOne)?.name ||
                                                            terr.adminOne 
                                                    }))
                                                })),
                                                doc_id: media.api_all_data.doc_id,
                                                query_id: media.api_all_data.query_id,
                                                changes_viewed: media.api_all_data.changes_viewed,
                                                monitoring_id: media.api_all_data.doc_id,
                                                monitoring_result_status: media.api_all_data.status,
                                                monitoring_status: media.api_all_data.monitoring_status ?? false,
                                                saved: media.api_all_data.saved,
                                            }
                                        }
                                    }));
                                    this.adverseResults = [...this.adverseResults, ...mappingValue];
                                }
                                
                                this.adverseResults = this.adverseResults.map((ele, index) => ({
                                    ...ele, 
                                    curr_index: index,
                                }));

                                this.adverseFilteredResults = this.adverseResults;
                                if (results[0]?.status === "rejected" || values[0]?.status === 500) {
                                    this.isLoading = false;
                                    this.$toast.error(this.$t('components.tools.media_monitoring.something_went_wrong_please_try_again'));
                                }

                                this.cardStatusResults = this.adverseFilteredResults;
                                if (this.adverseFilteredResults?.length)
                                    this.filterOptionsMaster = this.adverseFilteredResults.filter((el) =>
                                        el.api_all_data?.summary
                                    )?.[0]?.api_all_data?.summary;
                                
                                await this.getAllCardsDetails()
                                this.setCardStatusCounts()         
                                this.showTabTools = true
                                this.SET_ALL_TOOLS_DATA({...this._data, "tool-name": "sigma-tool"});
                                this.triggerRoute = true;
                                this.isLoading = false;
                                this.$emit("searchResult", {data: this.adverseResults, source: "sigma", searchType: "name"});
                                this.resetLoader("nameSearch");
                                this.$emit("getInitialQueryCount");
                                this.$emit("updateQueryTotal", { checkName: this.$route.query.check_name })
                                this.afterSearchResponseReceived({ searchResults: results })
                                this.$emit("updateToolData", "sigma-tool");
                            })
                            .catch((error) => {
                                if (error.response && error.response.status === 406) {
                                    const message = error.response?.data?.detail || this.$t('general.default_error2');
                                    this.$toast.error(message);
                                }
                                this.showResult = true;
                                this.isLoading = false;
                                this.resetLoader("nameSearch");
                            });
                        
                            return;
                    } else {
                        this.showResult = false;
                        this.isLoading = false;
                        this.resetLoader("nameSearch");
                    }
                }
                if (this.searchQuery) this.appliedFilterCount += 1;

                let data = cloneDeep(this.adverseResults);
                let searchKeyword = this.searchQuery.toLowerCase() ?? "";
                this.adverseFilteredResults = data.filter((ele) => ele?.title?.toLowerCase().includes(searchKeyword));
                this.cardStatusResults = this.adverseFilteredResults;
            }
            this.applyRiskFilters(this.tabsStatus.selected);

            this.$forceUpdate();
        },

        async handleBulkMonitoring() {
             // const monitoringStatus = event.target.checked;
            const querySource = this.autorun ? this.selectedQuery.query_payload : this.getSelectedToolQuery;
             this.isBulkMonitoringLoading = true;
             this.bulkMonitor = true;
             this.isBulkMonitorOn = !this.isBulkMonitorOn;
             let requestBody = {
                 product_name: this.getProduct.name,
                 product_id: this.getProduct.key,
                 case_id: this.getNeoCaseId,
                 query: {
                     query_id: querySource.query_id,
                     query_string: querySource.query_string,
                     search_string: querySource.search_string,
                 },
                frequency: this.$props.frequency ? this.$props.frequency : 30,
                 status: this.isBulkMonitorOn ? "enabled" : "disabled",
             };
             try {
                 const response = await mainAxios.post("/service/bulk-enable", requestBody);
                 if (response.status) {
                     this.$toast.success(this.$t('components.tools.media_monitoring.bulk_monitoring_updated_successfully'));
                     this.bulkMonitor = false;
                     let details = this.adverseFilteredResults;
                     details.map((el) => {
                         el.api_all_data.data.monitoring_status = this.isBulkMonitorOn;
                     });
                     this.adverseFilteredResults = cloneDeep(details);
 
                     this.$forceUpdate();
                     // setTimeout(() => {
                     //     (this.manualSearch("true"),5000)
                     // });
                 }
             } catch (error) {
                 this.$toast.error(error.message);
             }
             this.isBulkMonitoringLoading = false;
        },

        /**
         * @function
         * @name redirectTo - function to update input filters data to the route
         */
        redirectTo() {
            let query = this.$route.query;
            if (this.sigma_request_id)
                query = {
                    ...query,
                    query_id: this.sigma_request_id,
                };
            this.$router.push({path: this.$route.path, query: query}).catch(() => {});
        },

        async resetQueryFilter() {
            const filters = {
                monitoring: "all",
                saved: "all",
            };
            this.setToolsFilterData(filters);
            await this.getToolsStatus();
        },

        async autoInit() {
            try {
                await this.manualSearch();
                await this.getAllCardsDetails();
                await this.getToolsStatus();
                const confirmedCards = this.cardStatusResults.filter((res) => res.card_status === 'CONFIRMED');
                for (const index in confirmedCards)
                    this.handleRecordsConfirmation({
                        item: confirmedCards[index],
                        value: true
                    });
            } catch (error) {
                console.error(error);
            } finally {
                this.isLoading = false;
            }
        },

        async manualSearch(refreshFlag) {
            if (!this.isRunCheckAllowed) {
                return this.showRunCheckError();
            }

            this.triggerRoute = false;
            await this.search(refreshFlag);
        },

        /**
         * When tab is monitoring
         * Fetch monitoring results
         * @param {array} sources: []
         */
        async monitoringSearch() {
            this.showResult = true;
            if (this.limitPag == 1) {
                this.offset = 0;
                this.adverseResults = [];
            }
            this.searchedClicked = true;
            //To navigate to a different URL, according to the selected query
            this.redirectTo();
            if (this.limitPag > 1) {
                this.offset = Math.ceil((this.limitPag - 1) * 100);
            }
            const monitoringFilters = {
                startDate: this.dateRange[0],
                endDate: this.dateRange[1],
                dataType: this.selectedDataType.value
            }
            let values = await monitoringSearchData(this.getNeoCaseId, ["sigma"], this.$route.query.check_name, monitoringFilters ,this.getSelectedToolQuery , 0, 1000);
            this.latestVersionTotalResults = values.totalResults;
            this.totalRecordsInAllQueries = values.totalResults;
            this.totalCount = values.totalResults;
            if (values?.values?.length > 0) {
                let mediaMonitoring = this.getMappingValue(
                    values.values,
                    "mediaMonitoring",
                    SIGMA_TOOL_MAPPING
                );

                mediaMonitoring = mediaMonitoring.map((media) => ({
                    ...media,
                    score: (media.score * 100)?.toFixed(2),
                    api_all_data: {
                        ...media.api_all_data,
                        data: {
                            ...media.api_all_data.data,
                            articles: media.api_all_data.data.articles.map((article) => ({
                                ...article,
                                extractedTerritories: article.extractedTerritories.map((terr) => ({
                                    ...terr,
                                    country:  this.countriesOptions?.[0]?.categories?.find((el) => el.alpha_2_code === terr.country || el.alpha_3_code === terr.country)?.name || 
                                        terr.country,
                                    adminOne: this.stateOptions?.[0]?.categories?.find((el) => el.alpha_2_code === terr.adminOne || el.alpha_3_code === terr.adminOne)?.name ||
                                        terr.adminOne 
                                }))
                            })),
                        }
                    }
                }));
                // const monitoringDocIds = mediaMonitoring.map((res)=>res.api_all_data.data.doc_id)
                // this.adverseFilteredResults = this.adverseFilteredResults.filter((res)=>!monitoringDocIds.includes(res.api_all_data.data.doc_id))
                this.adverseFilteredResults = [...mediaMonitoring];
                this.adverseFilteredResults = this.adverseFilteredResults.map((ele, index) => ({
                    ...ele, 
                    curr_index: index,
                }));

                this.adverseResults = this.adverseFilteredResults;
                this.cardStatusResults = this.adverseFilteredResults;
                if (this.adverseFilteredResults?.length)
                    this.filterOptionsMaster = this.adverseFilteredResults.filter((el) =>
                        el.api_all_data?.summary
                    )?.[0]?.api_all_data?.summary;

                await this.getAllCardsDetails()
                this.setCardStatusCounts()              
            }
            this.$emit("getInitialQueryCount");
            this.$emit("updateQueryTotal", { checkName: this.$route.query.check_name })
        },

        /**
         * @function
         * @name search - function calls to perform search on the input filters
         *              - calls sources API to create a search query
         *              - calls search APIs on the selected sources
         */
        async search(refreshFlag) {
            this.tabsStatus.selected = 'all';
            this.monitoringStatus = false;
            this.closeExpandedResult();
            this.tabsStatus.selected = 'all';
            this.adverseFilteredResults = [];
            this.totalCount = 0;
            // this.isOldVersionSelected = false;
            // this.timeline = [];
            // this.updateMonitoringCascadingTimeline({
            //     timeline: this.timeline,
            //     meta_data: null,
            // });

            // this.isAllRunQueries = false;
            this.allQueriesParams = null;
            // for (let i = start; i >= 0; i--) {
            this.isResultExpanded = false;
            if (this.limitpag == 1) {
                this.adverseResults = [];
                this.offsetPag = 0;
                this.page_number = 1;
                this.adverseFilteredResults = [];
            }

            this.searchKeyword = this.selectedItem?.value ?? "";

            this.page_number = 1;
            this.searchItem = this.searchKeyword;
            // const selCountries = this.country?.value.length > 0 ? this.country.value.map((el) => el.value).sort((a, b) => a.localeCompare(b)) : [];
          
            if (!this.isSourceAuth("media_monitoring")) {
                this.allSources["mediaMonitoring"].isChecked = false;
                this.sources = this.sources.filter((e) => e !== "sigma");
            }
            if (this.monitoringActive && !this.isAllRunQueries) {
                this.startLoader("nameSearch");
                this.isFilterApplied = true;
                await this.filterData();
                this.resetLoader("nameSearch");
                return;
            }

            if (this.searchKeyword || this.isAllRunQueries) {
                if (!this.sources.length && !this.isAllRunQueries) {
                    this.$toast.error(this.$t('components.tools.media_monitoring.please_select_a_source'));
                    return;
                }

                this.sources = this.sources.sort((a, b) => a.localeCompare(b));
                this.searchedClicked = true;
                this.startLoader("nameSearch");
                this.isLoading = true;
                this.$emit("searched", {data: {name: this.searchKeyword}, source: "sigma"});
                try {
                    const headers = {
                        "x-tool-name": "sigma-tool",
                        "x-visited": true,
                        "x-refresh": refreshFlag || false,
                        "x-status": 'RUNNING',
                        "x-entity-id": this.$route.query.entityId,
                        "x-case-id": this.getNeoCaseId,
                        "x-wlp-reference": process.env.VUE_APP_BACKEND_URL,
                        ...this.autorun?.headers,
                    };
                
                    let mediaMonitoring;
                    if (this.allSources["mediaMonitoring"].isChecked && !this.validdate) {
                        Object.assign(this.sourceBody, this.prebuiltQueryPayload);

                        await this.createSigmaEntity();
                        this.monitoringActive = true;

                        const {data: sourcesCall} = await mainAxios.post("/service/sigma360/search_sources", {
                            ...this.sourceBody,
                            urn: this.sigmaUrn,
                        }, { 
                            headers: headers,
                        });
                        this.sigma_request_id = sourcesCall.request_id;
                        
                        const queryExists = this.searchedQueries.some((res) => res._id == sourcesCall.request_id);
                        if (!queryExists) {
                            this.monitoringActive = false
                        }

                        await this.getToolsStatus();
                        const query = this.searchedQueries.find((res) => res._id == sourcesCall.request_id);
                        if (this.isMonitoringPermitted && this.isProductMonitoring && this.isMonitoringAllowed) {
                            query.is_monitoring = true;
                            this.$forceUpdate();
                            await this.handleMonitoringStatus(query);
                        }
                        this.redirectTo();
                        this.showResult = true;
                        this.showSearch = false;

                        let reqBody = cloneDeep(this.sourceBody);
                        Object.assign(reqBody, this.prebuiltQueryPayload);
                        reqBody = {
                            ...reqBody,
                            additional_details: {
                                query_id: this.sigma_request_id,
                            },
                            urn: this.sigmaUrn,
                        };

                        if (this.nerFilters) reqBody.output_filters = this.nerFilters;
                        if (this.filters.monitoring !== "all" && this.isFilterApplied) {
                            reqBody.additional_details.monitoring_status = this.filters.monitoring === "monitoring";
                        }
                        if (this.filters.saved !== "all" && this.isFilterApplied) {
                            reqBody.additional_details.saved = this.filters.saved === "saved";
                        }
                        const query_payload = await this.getQueryPayload(reqBody, "sigma");

                        mediaMonitoring = await mainAxios.post("/service/sigma360/news", query_payload, {
                            headers: headers,
                        })
                    }
                
                    this.$emit("searched", {data: {name: this.searchKeyword}, source: "sigma"});
                    await this.setSearchedUser(this.searchKeyword);
                    if (mediaMonitoring) {
                        this.adverseResults = [];

                        await Promise.allSettled([mediaMonitoring])
                            .then(async (results) => {
                                let values = results.map((result) => result.value);
                                this.totalCount = values[0].data.data.length ;
                                if (values[0].data.data.length > 0) {
                                    let mappingValue = this.getMappingValue(values[0].data.data, "mediaMonitoring", SIGMA_TOOL_MAPPING);
                                    mappingValue = mappingValue.map((media) => ({
                                        ...media,
                                        score: (media.score * 100)?.toFixed(2),
                                        api_all_data: {
                                            ...media.api_all_data,
                                            data: {
                                                ...media.api_all_data.data,
                                                articles: media.api_all_data.data.articles.map((article) => ({
                                                    ...article,
                                                    extractedTerritories: article.extractedTerritories.map((terr) => ({
                                                        ...terr,
                                                        country:  this.countriesOptions?.[0]?.categories?.find((el) => el.alpha_2_code === terr.country || el.alpha_3_code === terr.country)?.name || 
                                                            terr.country,
                                                        adminOne: this.stateOptions?.[0]?.categories?.find((el) => el.alpha_2_code === terr.adminOne || el.alpha_3_code === terr.adminOne)?.name ||
                                                            terr.adminOne 
                                                    }))
                                                })),
                                                doc_id: media.api_all_data.doc_id,
                                                query_id: media.api_all_data.query_id,
                                                changes_viewed: media.api_all_data.changes_viewed,
                                                monitoring_id: media.api_all_data.doc_id,
                                                monitoring_result_status: media.api_all_data.status,
                                                monitoring_status: media.api_all_data.monitoring_status ?? false,
                                                saved: media.api_all_data.saved,
                                            }
                                        }
                                    }));
                                    this.adverseResults = [...this.adverseResults, ...mappingValue];
                                }
                                
                                this.adverseResults = this.adverseResults.map((ele, index) => ({
                                    ...ele, 
                                    curr_index: index,
                                    api_all_data: {
                                        ...ele.api_all_data,
                                        query_id: ele.api_all_data.data.query_id || this.sigma_request_id,
                                    }
                                }));

                                this.adverseFilteredResults = this.adverseResults;
                                if (results[0]?.status === "rejected" || values[0]?.status === 500) {
                                    this.showResult = true;
                                    this.isLoading = false;
                                    this.$toast.error(this.$t('components.tools.media_monitoring.something_went_wrong_please_try_again'));
                                }

                                this.cardStatusResults = this.adverseFilteredResults;
                                if (this.adverseFilteredResults?.length)
                                    this.filterOptionsMaster = this.adverseFilteredResults.filter((el) =>
                                        el.api_all_data?.summary
                                    )?.[0]?.api_all_data?.summary;

                                await this.getAllCardsDetails();
                                this.isFilterApplied = true;
                                await this.filterData();
                                this.showTabTools = true
                                this.SET_ALL_TOOLS_DATA({...this._data, "tool-name": "sigma-tool"});
                                this.showResult = true;
                                this.triggerRoute = true;
                                this.isLoading = false;
                                this.$emit("searchResult", {data: this.adverseResults, source: "sigma", searchType: "name"});
                                this.resetLoader("nameSearch");
                                this.$emit("updateQueryTotal", { checkName: this.$route.query.check_name })
                                this.afterSearchResponseReceived({ searchResults: results })
                                this.$emit("updateToolData", "sigma-tool");
                            
                            })
                            .catch((error) => {
                                if (error.response && error.response.status === 406) {
                                    const message = error.response?.data?.detail || this.$t('general.default_error2');
                                    this.$toast.error(message);
                                }
                                this.showResult = true;
                                this.isLoading = false;
                                this.resetLoader("nameSearch");
                            });
                        
                            return;
                    } else {
                        this.showResult = false;
                        this.isLoading = false;
                        this.resetLoader("nameSearch");
                    }
                } catch(error) {
                    console.log(error);
                    this.$toast.error(error?.response?.data?.detail)
                }
            } else {
                this.$toast.error(this.$t('components.tools.media_monitoring.please_enter_a_valid_input'));
                return;
            }
        },

        /**
         * @function
         * @name setSearchedUser - run input query on tool and then handle green tick in the dropdown
         * @params {searchKeyword} - input search string to be searched
         */
        async setSearchedUser(searchKeyword) {
            const data = {
                value: searchKeyword,
                platform: "sigma",
                val_type: this.entityType === "person" ? "name" : "company_name",
                visited: true,
                entity_id: this.$route.query.entityId
            };
            let url = `service/${this.case_id}/tools/profiles`;
            await setUsernamesDropdownData(url, data);

            let dataItem = this[`nameSearches`][0]?.categories.find((dataItem) => {
                return dataItem.value === searchKeyword;
            });
            if (dataItem) dataItem["visited"] = true;
            else if (data?.value) {
                this[`nameSearches`][0]?.categories.push(data);
                this.$emit("addCustomData", data);

                this.nameSearches[0].categories = uniqBy(this.nameSearches?.[0]?.categories, "value");
            }

            this.handleChecked(data);
        },

        /**
         * @function
         * @name redirectToQuery
         */

        redirectToQuery() {
            this.items_count = 10;
            this.offset = 0;
            this.limitPag = 1;
            if (this.$route?.query?.query_id) {
                let {query_id} = this.$route.query;
                let selected_query = this.toolSearchQueries?.find((el) => el._id === query_id);
                var {
                    entity_type,
                    entity_name,
                    filter_id,
                    aliases,
                    countries,
                    urn,
                    dob,
                    dateType,
                    start_time,
                    end_time
                } = selected_query?.query;
                if (entity_type || entity_name) {
                    this.entityType = entity_type;
                    this.selectedItem = {
                        name: entity_name,
                        value: entity_name,
                    };
                    this.searchKeyword = entity_name;
    
                    // this.group_ids.value = {
                    //   value: group_ids,
                    // };
    
                    this.sigmaUrn = urn;
    
                    if (dob) {
                        this.dob.drops[0].value = dob?.split("-")?.[2]
                        this.dob.drops[1].value = dob?.split("-")?.[1] ? this.dob.drops?.[1]?.props?.options?.[parseInt(dob?.split("-")?.[1], 10)]: "";
                        this.dob.drops[2].value = dob?.split("-")?.[0];
                    }

                    this.dateType.value = {
                        value: dateType || "past_24_hrs",
                        name: this.$t(`components.tools.media_monitoring.dateTypeOptions.${dateType || "past_24_hrs"}`),
                    }
    
                    this.countries.value = countries?.map((country) => 
                        this.countriesOptions?.[0]?.categories.find((el) => el.alpha_2_code.toLowerCase() === country.toLowerCase())
                    ) || [];
                    
                    this.filter_id.value = this.filterOptions.filter((fil) => fil.value === filter_id)
                    this.start_time = start_time;
                    this.end_time = end_time;
                    if (start_time && end_time && dateType === 'custom')
                        this.dateRangeFilter.value =  [new Date(start_time).getTime(),  new Date(end_time).getTime()];
                    this.aliases.value = aliases?.join(',');
                    this.search();
                } else if (this.searchedClicked) {
                    this.search();
                }
            } else {
                this.redirectTo();
            }
        },

        loadMoreCompanies(pageNumber) {
            this.page_number = pageNumber;
        },

        async updateEntityType() {
            await this.resetFilter();
            this.setAutoPopulateValue();
            // this.setExpandSection();
        },

        async mapInputFilters() {
            for (let source in this.allSources) {
                let key = "filters";
                if (source === "mediaMonitoring") 
                    key = (this.entityType === "person" || this.entityType === "any") ? 
                        "person_filters" : 
                        "company_filters";
                this.allSources[source].filterSections = this.allSources[source].filterSections.map((section) => ({
                    ...section,
                    filters: section[key].map((filter) => ({
                        ...this[filter],
                        class: ['aliases', 'countries'].includes(filter) && !(this.entityType === "person" || this.entityType === "any") ? 'custom-cols-2' : this[filter].class,
                        // value: source === "mediaMonitoring" ? (this[filter].type === "string" ? "" : null) : "",
                        key: filter,
                    })),
                }));

               
            }
        },

        /**
         * @function
         * @name initalizeData - Initalize inpput variables
         */
        async initalizeData() {
            try {
                this.loading= true;
                this.allSources["mediaMonitoring"].isChecked = true;
                await this.mapInputFilters();
                this.loading= false;
            } catch(err) {
                console.log("erreor ", err)
                this.loading= false;
            }
            
        },

        /**
         * @function
         * @name fillYears - Calculate and fill years dropdown with last 100 years
         */
        fillYears() {
            const now = new Date().getUTCFullYear();
            this.dayOptions = Array(31)
                .fill("")
                .map((i, idx) => idx + 1);
            (this.monthOptions = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]),
                (this.yearOfBirthOptions = Array(now - 1899)
                    .fill("")
                    .map((v, idx) => now - idx));
            this.yearOfBirth.props.options = this.yearOfBirthOptions;
            this.dob.drops[0].props.options = this.dayOptions;
            this.dob.drops[1].props.options = this.monthOptions;
            this.dob.drops[2].props.options = this.yearOfBirthOptions;
        },

        /**
         * @function
         * @name fetchAllJuridictions - get all jusridiction list and map in the jurisdiction dropdown
         */

        async fetchAllJuridictions() {
            const {data} = await mainAxios.get("tenant-check/jurisdictions?us_states=true");
            const jurisdiction = data.jurisdictions.map((el) => ({
                name: el.name,
                value: el.alpha_2_code,
                alpha_2_code: el.alpha_2_code,
                alpha_3_code: el.alpha_3_code,
                aka: el.aka
            }));

            const subJurisdictions = data.us_states.map((el) => ({
                name: el.name,
                // value:  el.alpha_3_code + '-' + el.alpha_2_code,
                value:  el.alpha_2_code,
                alpha_2_code: el.alpha_2_code,
                alpha_3_code: el.alpha_3_code,
                aka: el.aka
            }));
            this.countriesOptions =  [
                {
                    group: "Countries",
                    tGroup:"components.tools.media_monitoring.countries",
                    categories: jurisdiction,
                },
            ];
            this.stateOptions =  [
                {
                    group: "US States",
                    tGroup:"components.tools.media_monitoring.us_states",
                    categories: subJurisdictions,
                },
            ];

            this.countries.props.options = this.countriesOptions;
        },

        /**
         * @function
         * @name fetchFilterSet - get all filter set options
         */

        async fetchFilterSet() {
            const {data} = await mainAxios.get("service/sigma360/saved-filters", {
                headers: {
                    "x-tool-name": "sigma-tool",
                    "x-case-id": this.getNeoCaseId,
                    "x-wlp-reference": process.env.VUE_APP_BACKEND_URL,
                }
            });

            this.filterOptions = data.filters.map((el) => ({
                name: el.name,
                value: el.id.toLowerCase(),
                default: el.default,
            }));

            this.filter_id.props.options = this.filterOptions;
            this.filter_id.value = this.filterOptions.filter((el) => el.default);
        },

        /**
         * @function
         * @name resetFilter - reset all search inputs and filters
         */
        async resetFilter(reset) {
            // this.entityType = "person";
            this.isFilterApplied = false;
            this.sources = ["sigma"];
            for (let source in this.allSources) {
                this.allSources[source].isChecked = false;
            }
            this.loaderController = {
                nameSearch: {
                    loading: false,
                    success: false,
                    filterLoading: false,
                    filterSuccess: false,
                },
            };
            this.request_id = "";
            this.sigma_request_id = "";
            this.sigmaUrn = "";
            this.start_time = null;
            this.end_time = null;
            this.dropValue = "";
            this.entityCount = 1;
            this.queries = [];
            this.selectVal = [""];
            this.showResult = false;
            this.showFiltersPanel = false;
            this.adverseResults = [];
            this.adverseFilteredResults = [];
            this.searchQuery = "";
            this.filterJurisdiction = [];
            this.items_count = 10;
            this.filters = {
                saved: "all",
                monitoring: "all",
            };
            this.isAllRunQueries = false;
            this.allQueriesParams = null;
            this.offsetPag = 0;
            this.limitPag = 1;
            this.isOldVersionSelected = false;
            this.timeline = [];
            this.validdate = false;
            if (reset) {
                this.selectedItem = null;
                this.searchKeyword = "";
            }
            for (let source in this.allSources) {
                for (const si in this.allSources[source].filterSections) {
                    const section = this.allSources[source].filterSections[si];
                    // if (source === "mediaMonitoring") section.expanded = false;
                    for (const fi in section.filters) {
                        const filter = section.filters[fi];
                        if (filter.key === "dob") {
                            this[filter.key].drops[0].value = "";
                            this[filter.key].drops[1].value = "";
                            this[filter.key].drops[2].value = "";
                        // } else 
                        // this[filter.key].value = filter.value
                        } else if (filter.key === "dateType") {
                            this[filter.key].value = {
                                value: "past_24_hrs",
                                name: this.$t(`components.tools.media_monitoring.dateTypeOptions.past_24_hrs`),
                            }
                        } else if (filter.type === "string") this[filter.key].value = "";
                        else if (filter.type === "datepicker") this[filter.key].value = [];
                        else if (filter.props && filter.props.options) {
                            if (filter.key === 'filter_id')
                                this[filter.key].value = this.filterOptions.filter((el) => el.default);
                            else if (filter.props.multiple)
                                this[filter.key].value = [];
                            else
                                this[filter.key].value = null;
                        }
                    }
                }
            }
            await this.initalizeData();
            // this.updateMonitoringCascadingTimeline({
            //     timeline: this.timeline,
            //     meta_data: null,
            // });
            this.redirectTo();
            this.$forceUpdate();
        },

        closeExpandedResult() {
            this.isResultExpanded = false;
            this.selectedResultCard = null;
            this.isOldVersionSelected = false;
        },
        resetPage() {
            this.page_number = 1;
            this.closeExpandedResult();
        },
        async handlePageChange(page_number) {
            if (this.$route.name === "monitoring" && this.getTotalPages - 1 <= this.page_number && this.adverseResults.length >= this.items_count * this.page_number && this.latestVersionTotalResults != this.adverseResults.length) {
                this.offsetPag += 1;
                this.limitPag += 1;
                this.manualSearch();
            }
            this.loadMoreCompanies(page_number);
            this.closeExpandedResult();
            this.scrollToTop();
            if (this.isAllRunQueries) {
                if (this.getTotalPages - 1 <= this.page_number && this.cardStatusResults.length >= this.items_count * this.page_number) {
                    await this.onRunAllQueries(null, "adverseResults");
                }
            }
        },
        scrollToTop() {
            // document.getElementById("adverse-media").scrollTo({
            //     top: "0px",
            //     behavior: "smooth",
            // });
            // document.getElementById("result-list-data").scrollTo({
            //     top: 1,
            //     behavior: "smooth",
            // });
            document.querySelector("section#result-list").scrollTop = 0;
        },

        /**
         * @function
         * @name clearFilters - function to clear output filters
         */
        async clearFilters(fetchDataFlag) {
            this.page_number = 1;
            this.searchQuery = "";
            this.filterMatchedEntity = "";
            this.filterRiskType = [];
            this.filterEntityRisk = [];
            this.filterPublicationDate = [];
            this.filterPublisherCountry = [];
            this.filterPublisherRegion = [];
            this.filterPublisherSubRegion = [];
            this.filterMentions = [];
            this.filterLanguages = [];
            this.isFilterApplied = false;
            this.filterJurisdiction = [];
            this.filters = {
                saved: "all",
                monitoring: "all",
            };
            this.dateRange = [];
            this.setDefaultFilters();
            this.closeExpandedResult();
            if (this.isAllRunQueries) {
                this.offsetPag = 0;
                this.limitPag = 1;
                this.isNextPag = true;
                this.adverseResults = [];
            }
            if (fetchDataFlag) {
                this.startLoader("nameSearch");
                await this.onApplyFilter();
                this.resetLoader("nameSearch");
            }
        },

        onInput(value, field) {
            if (value)
                this[field] = {
                    name: value,
                    value: value,
                };
            else this[field] = null;
        },

        closeDropdown(ref, field) {
            this.$refs[ref].search = field?.value ?? "";
        },

        /**
         * @function
         * @name cancelUpload - function to cancel the file uploader
         */

        cancelUpload() {
            this.$refs["uploadBtn"].cancelUpload();
        },
        resultListStyles() {
            // isResultExpanded && 'width:40% !important;' && isMonitoringTab ? 'max-height: calc(100% - 202px)' : 'max-height: calc(100% - 128px)'
            let styles = "";
            if (this.isQueryPanelExpanded && this.isResultExpanded) styles += "width:30% !important ;";
            else if (this.isResultExpanded && !this.isQueryPanelExpanded) styles += "width:40% !important;";
            return styles;
        },
        // isResultExpanded ? 'width:60% !important;' : $route.name == 'monitoring' ? ' max-height: calc(100% - 240px)!important; ' : ' max-height: calc(100% - 140px)!important;'
        getStyles() {
            let styles = " ";
            if (this.isQueryPanelExpanded && this.isResultExpanded) styles += "width:70% !important ;";
            else if (this.isResultExpanded && !this.isQueryPanelExpanded) styles += "width:60% !important;";
            // if (this.$route.name == "monitoring") styles += " max-height: 100% - 100px)!important; ";
            // else styles += " max-height: 100% !important; ";
            return styles;
        },

        /**
         * @function
         * @name handleMarkAsAllDone
         * @params {e} - pointer event for Monitoring - mark all done input checkbox
         */
        async handleMarkAsAllDone(event) {
            const visited = event.target.checked;
            const payload = {
                case_id: this.getNeoCaseId,
                entity_id: this.$route.query.entityId,
                query_id: !this.isAllRunQueries ? this.getSelectedToolQuery.query_id: undefined,
                tool_name: this.$route.query.check_name || this.autorun?.headers['x-tool-name'],
                visited: visited,
                status: this.tabsStatus.selected && this.tabsStatus.selected !== 'all' ? 
                    (
                        this.tabsStatus.selected.toUpperCase() !== 'UNKNOWN' ? 
                            this.tabsStatus.selected.toUpperCase() : 
                            ""
                    ) : 
                    undefined
            };
            
            try {
                const response = await getMarkAllAsDone(payload);
                if (response.success) {
                    // Update UI state for all results
                    this.adverseFilteredResults.forEach(advRes => {
                        advRes.api_all_data.data.changes_viewed = visited;
                    });
                    
                    if (this.timeline.length > 0) {
                        this.timeline = this.timeline.map(res => {
                            let obj = res;
                            obj.api_all_data.data.changes_viewed = visited;
                            return obj;
                        });
                    }
                    this.$emit('getQueriesMonitoring');
                    this.$emit("updateQueryTotal", { checkName: this.$route.query.check_name })
                }
            } catch (error) {
                console.error("Error marking all as done:", error);
            }
        },

        /**
         * @function
         * @name isSourceAuth
         * @params {String} src - selected source (media_monitoring)
         */
        isSourceAuth() {
            return true
        },

        /**
         * @function
         * @name handleFilterApplied
         * @params {Object} filter - selected filter
         */
        async handleFilterApplied(filter) {
            let match = -1;
            switch (filter.name) {
                case "monitoring":
                    this.selectedDataType = {label: "All Results", value: "all_results"};
                    break;
                case "monitoringDateRange":
                    this.dateRange = [];
                    break;
                case "filterMatchedEntity":
                    this.filterMatchedEntity = "";
                    break;
                case "filterRiskType":
                    match = this[filter.name].findIndex((el) => el.eventType === filter.value);
                    if (match > -1) this[filter.name].splice(match, 1);
                    break;
                case "filterPublicationDate":
                    this.filterPublicationDate = [];
                    break;
                case "filterPublisherCountry":
                case "filterMentions":
                case "filterLanguages":
                    match = this[filter.name].findIndex((el) => el.label === filter.value);
                    if (match > -1) this[filter.name].splice(match, 1);
                    break;
                default:
                    match = this[filter.name].findIndex((el) => el.label === filter);
                    if (match > -1) this[filter.name].splice(match, 1);
                    break;
            }
            this.page_number = 1;
            await this.onApplyFilter();
        },

        /**
         * @function
         * @name parseValue
         * @params {Object} value - selected filter value
         */
        parseValue(value) {
            return typeof value === "string" ? value : value.label || value.name || value.value;
        },

        /**
         * @function
         * @name toggleAllSources - toggle selection of all sources
         */
        toggleAllSources() {
            if (!this.allSourcesChecked) {
                for (let source in this.allSources) this.allSources[source].isChecked = true;
                this.sources = ["sigma"];
            } else {
                for (let source in this.allSources) this.allSources[source].isChecked = false;
                this.sources = [];
            }
        },
        async onApplyFilter() {
            this.isFilterApplied = true;
            const {monitoring, saved} = this.prevAppliedFilters;
            const {monitoring: fil_monitoring, saved: fil_saved} = this.filters;

            if (fil_monitoring != monitoring || fil_saved != saved) {
                if (this.isAllRunQueries) {
                    this.offsetPag = 0;
                    this.limitPag = 1;
                    this.isNextPag = true;
                    this.adverseResults = [];
                    await this.onRunAllQueries(null, "adverseResults");
                } else await this.search();
            }
            await this.filterData();
            this.setPrevFilters();
            this.$forceUpdate();
            // await this.getToolsStatus();
        },
        async onBackToSearch() {
            this.timeline = []
            this.showTabTools = false
            this.request_id = null;
            this.sigma_request_id = null;
            this.sigmaUrn = null;
            this.start_time = null;
            this.end_time = null;
            this.entityCount = 1;
            this.queries = [];
            this.selectVal = [""];
            this.showResult = false;
            this.showFiltersPanel = false;
            this.isFilterApplied = false;
            this.searchQuery = "";
            this.filterJurisdiction = [];
            this.items_count = 10;
            this.monitoringActive = false;

            this.filters = {
                saved: "all",
                monitoring: "all",
            };
            this.isAllRunQueries = false;
            this.allQueriesParams = null;
            this.offsetPag = 0;
            this.limitPag = 1;
            this.isExpandedLoaded = false;

            const entityName = this.prebuiltQueryPayload?.name || this.getSelectedEntity?.entity_name;
            this.selectedItem = {
                value: entityName,
            };
            this.filter_id.value = this.filterOptions.filter((el) => el.default);
            this.dateType.value = {
                value: "past_24_hrs",
                name: this.$t(`components.tools.media_monitoring.dateTypeOptions.past_24_hrs`),
            };
            this.searchKeyword = entityName;
            this.resetLoader("nameSearch");
            this.setPrevFilters(this.filters);
            this.setToolsFilterData(this.filters);
            await this.getToolsStatus();
            this.setExpandSection();
            this.$forceUpdate();
        },
        getFormattedTime(ts) {
            if (ts) {
                let date = new Date(ts).toISOString();
                date = DateTime.fromISO(date);
                return date.toFormat("dd MMM yyyy");
            }
            return "-";
        },
        setPrevFilters() {
            let {monitoring, saved} = this.filters;
            this.prevAppliedFilters = {
                monitoring,
                saved,
                searchQuery: this.searchQuery,
                filterJurisdiction: this.filterJurisdiction,
            };
        },
        async onPerPageChange(pageCount) {
            this.items_count = pageCount;
            this.page_number = 1;
            if (this.adverseResults.length <= this.items_count) {
                if (this.isAllRunQueries) {
                    this.adverseResults = [];
                    this.offsetPag = 0;
                    this.limitPag = 1;
                    await this.onRunAllQueries(null, "adverseResults");
                    if (this.adverseResults.length <= this.items_count) {
                        this.offsetPag = 1;
                        this.limitPag = 2;
                        await this.onRunAllQueries(null, "adverseResults");
                    }
                } else {
                    this.manualSearch();
                    if (this.latestVersionTotalResults > 100) {
                        this.offsetPag += 1;
                        this.limitPag += 1;
                        await this.manualSearch();
                    }
                }
                this.scrollToTop();
            }
        },

        async handleSearch() {
            if (!this.isSearchBtnDisabled) {

                try {
                    this.setQueryResultLoader(true);
                    let globalFilters = false;
                    globalFilters = await this.checkGlobalFilters();
                    if (!globalFilters) {
                        await this.manualSearch();
                        await this.resetQueryFilter();
                    } 
                } catch(e){
                    console.error(e)
                } finally{
                    this.setQueryResultLoader(false)
                }
            }
        },

        async checkGlobalFilters() {
            if (this.nerFilters) {
                try {
                    const confirm = await this.$refs["modal-confirm"].show({
                        title: this.$t('components.tools.media_monitoring.reset_global_filters_title'),
                        message: this.$t('components.tools.media_monitoring.reset_global_filters_message'),
                        autoclose: false,
                    });
                    if (confirm) {
                        this.$emit("handleNerClear");
                        this.$refs["modal-confirm"].close();
                        return false;
                    } else return true;
                } catch (error) {
                    this.$refs["modal-confirm"].close();
                }
            } else return false;
        },

        async showMonitoringHistory(data) {
            let payload = data.payload;
            payload.case_id = this.getNeoCaseId
            payload.tool = this.$route.query.check_name
            payload.source = "sigma"
            let source = [];
            if (this.sources?.length > 0) {
                source = this.sources;
            }
            // delete payload.monitoringHistoryIndex;
            if (payload.monitoringHistoryIndex) {
                this.timeline = [];
                const values = await monitoringHistoryData(payload, source, this.$route.query.check_name);
                if (values?.length > 0) {
                    let mediaMonitoring = this.getMappingValue(
                        values,
                        "mediaMonitoring",
                        SIGMA_TOOL_MAPPING
                    );
                    mediaMonitoring = mediaMonitoring.map((media) => ({
                        ...media,
                        score: (media.score * 100)?.toFixed(2),
                        api_all_data: {
                            ...media.api_all_data,
                            data: {
                                ...media.api_all_data.data,
                                articles: media.api_all_data.data.articles.map((article) => ({
                                    ...article,
                                    extractedTerritories: article.extractedTerritories.map((terr) => ({
                                        ...terr,
                                        country:  this.countriesOptions?.[0]?.categories?.find((el) => el.alpha_2_code === terr.country || el.alpha_3_code === terr.country)?.name || 
                                            terr.country,
                                        adminOne: this.stateOptions?.[0]?.categories?.find((el) => el.alpha_2_code === terr.adminOne || el.alpha_3_code === terr.adminOne)?.name ||
                                            terr.adminOne 
                                    }))
                                })),
                            }
                        }
                    }));
                    this.timeline = [...this.timeline, ...mediaMonitoring];
                    this.timeline = this.timeline.map((ele, index) => ({...ele, current_index: index, isOldVersion: true}));
                    this.timeline.forEach((res)=> {
                        res.card_status = this.cardDetailsMap[res.api_all_data.data.doc_id] && this.cardDetailsMap[res.api_all_data.data.doc_id].status!='None'  ? this.cardDetailsMap[res.api_all_data.data.doc_id].status : 'UNKNOWN'
                        res.customer_notes =  this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id].customer_notes : ''
                        res.research_notes =  this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id].notes : ''
                        res.risk_categories = this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id].risk_categories : []
                        res.bespoke = this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id]?.bespoke : []
                        res.entity_status = this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id]?.entity_status : 'Red'
                        res.screenshot = this.cardDetailsMap[res.api_all_data.data.doc_id] ? this.cardDetailsMap[res.api_all_data.data.doc_id]?.screenshot : {}
                    })
                }
                const parent = {
                    ...data.detail,
                    is_parent: true,
                };
                const meta_data = {
                    searchedQueryKeyword: this.searchKeyword,
                    fieldType: this.entityType,
                    selectedQuery: this.selectedQuery,
                };
                this.updateMonitoringCascadingTimeline({
                    timeline: cloneDeep(this.timeline)
                        .reverse()
                        .concat([parent]),
                    meta_data: meta_data
                   
                });
                this.setCardStatusCounts()
            } else {
                this.timeline = [];
                this.updateMonitoringCascadingTimeline({
                    timeline: this.timeline,
                    meta_data: null,
                });
                this.setCardStatusCounts()
            }
        },

        updateComparisonReferences(details) {
            if (this.isComparisonModeOn) {
                const isOldVersion = details.isOldVersion;
                if (isOldVersion) {
                    this.updateMonitoringCascadingTimeline({
                        newData: details,
                    });
                } else {
                    const parent = {
                        ...details,
                        is_parent: true,
                    };
                    this.updateMonitoringCascadingTimeline({
                        newData: parent,
                    });
                }
            }
        },

        makeDataForGraph(data, source) {
            const payload = {
                tool_data:
                    data?.map((el) => ({
                        doc: el.doc,
                        card_name: el.doc.name,
                    })) ?? [],
                extra_fields: {
                    search_string: "",
                    query_data: {
                        entity_type: "",
                    },
                    source: source,
                },
                case_id: this.case_id || "",
            };

            return payload;
        },

        getAddress(address) {
            if (address) {
                if (Array.isArray(address)) return address;
                else {
                    let obj = [address];
                    return obj;
                }
            } else return [];
        },

        isInvalid(value, type) {
            let valid = true;
            let pattern;
            if (type === "name") {
                pattern = /^[a-zA-Z-"]+$/; 
                valid = pattern.test(value);
            } else if (type === "dob") {
                if (this.entityType === "person") {
                    const filter = this.allSources["mediaMonitoring"].filterSections?.[0].filters?.[0];
                    const date = filter.drops?.[0].value;
                    const month = filter.drops?.[1].value;
                    const year = filter.drops?.[2].value;
                    if (date && month && year) return new Date(`${month}-${date}-${year}`) < new Date() ? false : true;
                    else return false;
                } else return false;
            }
            return value && !valid;
        },

        handleRecordsConfirmation(event) {
            this.$emit("recordsConfirmation", event);
        },
        async getSavedQueryList(){
            try{
                const url = `/case/case-check/${this.$route.query.check_id}/pre-build-query`
                let { data } = await mainAxios.get(url);
                this.$store.commit("SET_SAVED_QUERIES", data);
            }
            catch(error){
                this.$toast.error(error.response.data.detail)
            }
        },
        async handleSaveSearchQueryData(payload) {
            try{
                const url = `/case/case-check/${this.$route.query.check_id}/pre-build-query`
                let { data } = await mainAxios.post(url, payload);
                this.$toast.success(data.detail)
                await this.getSavedQueryList()

            }
            catch(error){
                this.$toast.error(error.response.data.detail)
            }
        },
        async updateQueryData(payload, queryId){
            try {
                let url = `/tenant-check/${this.$route.query.check}/pre-build-query/${queryId}`;
                let { data } = await mainAxios.put(url, payload);
                this.$toast.success(data?.detail);
                
            } catch (error) {
                this.$toast.error(error.response.data.detail);
            }
        },

        formatDate(date) {
            if (!date) return "";

            let formatDate = '';
            formatDate = DateTime.fromMillis(date);
            formatDate = formatDate.toFormat("dd/MM/yyyy");
            return formatDate;  
        },

        async createSigmaEntity() {
            const headers = {
                "x-tool-name": "sigma-tool",
                "x-visited": true,
                "x-refresh": false,
                "x-status": 'RUNNING',
                "x-entity-id": this.$route.query.entityId,
                "x-case-id": this.getNeoCaseId,
                "x-wlp-reference": process.env.VUE_APP_BACKEND_URL,
                ...this.autorun?.headers,
            };
            const { data: sigmaEntityCreationCall } = await mainAxios.post("/service/sigma360/create-entity", this.sourceBody, { 
                headers: headers
            });
            if (sigmaEntityCreationCall.urn)
                this.sigmaUrn = sigmaEntityCreationCall.urn;
            else this.$toast.error(sigmaEntityCreationCall.detail)
        },

        async archiveSigmaEntity(urn) {
            try {
                const headers = {
                    "x-tool-name": "sigma-tool",
                    "x-entity-id": this.$route.query.entityId,
                    "x-case-id": this.getNeoCaseId,
                    "x-wlp-reference": process.env.VUE_APP_BACKEND_URL,
                };
                await mainAxios.post("/service/sigma360/entity/archive", {
                    urn: [urn],
                }, { 
                    headers: headers
                });
            } catch(error) {
                this.$toast.error(error.response.data.detail)
            }
        }
    },
};
